import React, { Component } from 'react';
import { Link, withRouter, useNavigate  } from 'react-router-dom';
import { createBrowserHistory } from 'history'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import CheckoutForm from './CheckoutForm';
import FreeProductPopup from './Freeproduct';
import FreeProductListPopup from './Freeproductlist';

import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Contiueshopping from "./Contiueshopping";

import { BaseUrl } from '../common/config';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import moment from 'moment';

import Popup from '../common/popup';
import Showalert from '../common/Showalert';
import CommonAlert from '../common/Commonalert';
import Loader from '../common/loader';

import darkinfo from '../assets/images/dark-info.svg'
import whiteinfo from '../assets/images/color-info.svg'
import NoImage from '../assets/images/no-image.jpg';
import discountIcon from '../assets/images/discount-icon.png';
import payMethImg from '../assets/images/payment-accept.png';


// const stripePromise = loadStripe('pk_test_51IEaLXG3xjUozJh99yZr3NfT0Rc6U3yRogulW6WUhbm1We4w58A1FT9aO76l8GvcQnRiu4esitSBOl7XtEm90gf500YPcB6Buf');
//const stripePromise = loadStripe('pk_test_51NJehvJKUB6VvhPxXNEtsNn4uoGrx95nzpSEteW7ah3nnK5Y3x6Ma7y5cKtdMxzunPQrcLLmWG7fvQWHms4sGnq600ATP1xs5k');

class CheckoutPay extends Component {


    constructor(props) {
     
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        super(props);
        this.state = {
            products: [],
            loading: false,
            tempProducts: [],
            payBool: false,
            startDate: new Date(),
            TimeSlot: [],
            deliveryDate: "",
            checkboxErrMsg: "",
            deliveryDateErrMsg: "",
            deliveryTimeErrMsg: "",
            categories: [],
            categoryProducts: [],
            categoryProductsFree: [],
            viewImage: "",
            cartSubTotal: 0,
            cartTotal: 0,
            productImageIndex: "",
            allDays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
            deliverableDays: 'monday/thursday',
            // allergens: ['CELERY', 'CEREALS CONTAINING GLUTEN', 'CERELAS', 'GLUTENS', 'GLUTEN',  'WHEAT', 'BARLEY', 'OATS', 'CRUSTACEANS', 'CRUSTACEAN', 'EGGS', 'EGG', 'FISH', 'LUPIN', 'MILK', 'MOLLUSCS', 'MUSTARD', 'PEANUTS', 'SESAME SEEDS', 'SESAME', 'SOYBEANS', 'SULPHUR DIOXIDE', 'SULPHITES', 'SULPHITE', 'TREE NUTS', 'NUTS', 'WHEAT GLUTEN', 'SOYA', 'CEREALS', 'CEREAL', 'SOY'],
            // ingredientsHigh: ['CELERY', 'CEREALS CONTAINING GLUTEN', 'CERELAS',  'GLUTENS', 'GLUTEN', 'WHEAT', 'BARLEY', 'OATS', 'CRUSTACEANS', 'CRUSTACEAN','EGGS', 'EGG', 'FISH', 'LUPIN', 'MILK', 'MOLLUSCS', 'MUSTARD', 'PEANUTS', 'SESAME SEEDS', 'SESAME', 'SOYBEANS', 'SULPHUR DIOXIDE', 'SULPHITES', 'SULPHITE', 'TREE NUTS', 'NUTS', 'PRAWN', 'CRAB', 'LOBSTER', 'MUSSELS', 'OYSTERS', 'ALMONDS', 'HAZELNUTS', 'WALNUTS', 'BRAZIL NUTS', 'CASHEWS', 'PECANS', 'PISTACHIOS', 'MACADAMIA NUTS', 'WHEAT GLUTEN', 'SOYA', 'CEREALS', 'CEREAL', 'SOY'],

            allergens: [],
            ingredientsHigh: [],
            alertPopup: false,
            visibleAlert:false,
            disableButton: 0,
            hoildaysArray: [],
            holidaysDays: [],
            delete_item_popup:false,
            removeProduct: [],
            freeProductIds: (localStorage.getItem('freeProductIds') !=='' && localStorage.getItem('freeProductIds') !== undefined ? new Array(localStorage.getItem('freeProductIds')) : []),
            freeProductOpen: false,
            delete_item_popup_free: false,
            delete_item_popup_free_message: '',
            offerProductQty: '',
            common_alert_popup: false,
            common_alert_message: '',
            removeFreeProduct: [],
            removeFreeProductQty:'',
            freeProductData:[],
            addtoCartTypeQty: '',
            freeProductQty: 1,
            offerproductQtyRemaing: 0,
            productValueIndex:[],
            decrease_alert_popup: false,
            decrease_alert_popup_message: '',
            decreaseItem: [],
            delete_item_alert_popup: false,
            delete_item_alert_message: '',
            delete_single_Item: [],
            offerproducts:'',
            freeItemCount: 0,
            freeProductAlert: false,
            minmumAmountError:false,
            cartOriginalTotal: 0,
            settingsList:[],
            taxProductTotalAmount: 0,
            vatTaxAmount: 0,
            paymentmodevalue: '',
            orderPlacedStatus: false,
            minimumOrderAmount: 0,
            offerCombineProducts: [],
            offerCombineFreeProducts: [],
            freeProductDataFour: [],
            freeProductDataFive: [],
            orderDateError: false,
            creditLimitError: false,
            freeProductListOpen: false,
            offerProductData: [],
            accountObjective1: (loginDetails.accountObjective1 !== '' && loginDetails.accountObjective1 > 0  ? parseInt(loginDetails.accountObjective1) : 4),
            accountObjective2: (loginDetails.accountObjective2 !== '' && loginDetails.accountObjective2 > 0  ? parseInt(loginDetails.accountObjective2) : 5),
            deliveryDateError: false,
            uktimeerror: false
        };

        if(localStorage.getItem("sitemaintanance") == '1'){
            window.location.href = '/sitemaintanance';
        }else if (!localStorage.getItem("isLoggedIn")){
            window.location.href = '/';
        }

        this.notDeliverable = this.notDeliverable.bind(this);
        this.deliveryDateChange = this.deliveryDateChange.bind(this);
        // this.deliveryTimeChange = this.deliveryTimeChange.bind(this);

        this.getSettings();

    }

    componentDidMount() {
        this.timeSlot();
        this.getSeprateProducts();
        this.hoildaysList();
        this.offerProduct();
        this.allergensList();
        this.ingredientsList();

        this.setState({ loading: true });

        if(localStorage.getItem("accountDeliverableDays") === '' || localStorage.getItem("accountDeliverableDays") == '#N/A'){

            this.setState({deliveryDateError: true});
        }

    }


    allergensList(){

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "allergenlist";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;
            var allergendata = [];
                responseData.map((item)=>{
                 allergendata.push(item.allergenTitle);
                });
            this.setState({ allergens: allergendata});

         }).catch((err) => {
            console.log(err);
         });
    }

    ingredientsList(){

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "ingredientlist";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;
            var ingredients = [];
                responseData.map((item)=>{
                 ingredients.push(item.ingredientTitle);
                });
            this.setState({ ingredientsHigh: ingredients});
         }).catch((err) => {
            console.log(err);
         });
    }


    getSettings(){

    var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
    }

     let URL = BaseUrl + "settings";
         axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data[0];
            if(responseData !==''){
            this.setState({ settingsList: responseData, minimumOrderAmount: responseData.minimumOrderAmount });
           }
         }).catch((err) => {
            console.log(err);
         });
    }

    hoildaysList(){

      var loginDetails = {};
         if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
       }

       let URL = BaseUrl + "holidays";
       axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
        var response = response.data.data;
        this.setState({hoildaysArray: response, loading: false}, function(){
        this.getHolidays();
        });
        }).catch((err) => {
          this.setState({ loading: false });
        });

    }


    offerProduct(){

    var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
         }

     let URL = BaseUrl + "admin/offerlist";

       axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {

        //let responseData = response.data.data[0];

        let responseList = response.data.data;

        responseList.sort((a,b) => Number(a.freeProductQtyToAdd) - Number(b.freeProductQtyToAdd));

        let responseData = responseList[0];

        if(response.data.data.length > 0 && response.data.data.length == '1'){

        let responseList = response.data.data;

        responseList.sort((a,b) => Number(a.freeProductQtyToAdd) - Number(b.freeProductQtyToAdd));

        let responseDataFour = responseList[0];
        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var combineArray = list1;
        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var combineOfferArray = offerlist1;  

        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseDataFour, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: []}, function(){
            this.offerProductData(duplicateArrayRemoveOffer);
            this.getFreeProductList(responseDataFour, duplicateArrayRemove);
            this.checkOfferProductCount(responseDataFour, duplicateArrayRemoveOffer);
        });

     }else{

        let responseDataFour = responseList[0];
        let responseDataFive = responseList[1];
        var combineArray = [];

        var list1 = responseDataFour.freeProductToAdd;
            list1 = list1.split(',');

        var list2 = responseDataFive.freeProductToAdd;
            list2 = list2.split(',');

         combineArray = list1.concat(list2);

        var offerlist1 = responseDataFour.productToBeAdded;
            offerlist1 = offerlist1.split(',');
        var offerlist2 = responseDataFive.productToBeAdded;
            offerlist2 = offerlist2.split(',');
        var combineOfferArray = offerlist1.concat(offerlist2);  


        var duplicateArrayRemove = combineArray.filter((item,
        index) => combineArray.indexOf(item) === index);

        var duplicateArrayRemoveOffer = combineOfferArray.filter((item,
        index) => combineOfferArray.indexOf(item) === index);

        this.setState({ offerproducts: responseData, offerCombineProducts: duplicateArrayRemoveOffer, offerCombineFreeProducts: duplicateArrayRemove, freeProductDataFour: list1, freeProductDataFive: list2}, function(){
            this.offerProductData(duplicateArrayRemoveOffer);
            this.getFreeProductList(responseData, duplicateArrayRemove);
            this.checkOfferProductCount(responseData, duplicateArrayRemoveOffer);
        });
     }


     }).catch((err) => {
        console.log(err);
     });

    }



    offerProductData(responseData){

        var offerproductsList = responseData;
        this.setState({ loading: true });
        let authData = { accountPriceListId: "" };
        authData = JSON.parse(localStorage.getItem('authData'));
        let productsId = { "$in": offerproductsList };
        let payload = {
            productIds: productsId,
            priceband: localStorage.getItem('priceband')
        }

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "productsbyids";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
            let responseData = response.data.data;
            this.setState({ offerProductData: responseData });
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false })
        });
    }


  checkOfferProductCount(responseData, duplicateArrayRemoveOffer){

        var offerProductLastQty = 0;
        var offerproductsList = responseData;
        var productToBeAdded = '';
        var stringSplit = '';

        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));

        if(duplicateArrayRemoveOffer !== ''){
            cartItemsFinal.map((cartItem) => {
                duplicateArrayRemoveOffer.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

        this.setState({offerProductQty: offerProductLastQty}, function(){

            this.getSeprateProducts();
        });

  }

    getFreeProductList(responseData, duplicateArrayRemove){

        var offerproductsList = responseData;
        // var productToBeAdded = offerproductsList.productToBeAdded;
        // var stringSplit = productToBeAdded.split(',');
        var returnProductNumber = '';

        if(duplicateArrayRemove !==''){

        // var freeProductToAdd = offerproductsList.freeProductToAdd;
        // var stringFreeSplit = freeProductToAdd.split(',');
        let productsId = { "$in": duplicateArrayRemove };
        let payload = {
            productIds: productsId,
            //priceband: localStorage.getItem('priceband')
        }

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "freeproductsbyids";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
         this.setState({freeProductData: response.data, freeProductDisplayList: response.data, loading: false});
        }).catch((err) => {
        });

       }else{

        this.setState({freeProductData: [], freeProductDisplayList: [], loading: false});

       }

    }


    getHolidays(){

     var hoildays_list = this.state.hoildaysArray;

     var push_arr = [];

     if(hoildays_list !== ''){

        hoildays_list.map((data,index)=>{

            push_arr.push(new Date(data.holidayDate));

        });

     }

     this.setState({holidaysDays: push_arr});

    }

    PlaceOrder() {


        let cartData = [];
        let sumCart = 0;
        let cartDetails  = JSON.parse(localStorage.getItem('cartItems'));
        var freeItemCheck = 0;
        var vatProductCheck = 0;

        cartDetails.map((cartItem)=>{
            if(cartItem.product_type === 'Free'){
                freeItemCheck++;
            }
            if(cartItem.productTaxVal > 0){
                vatProductCheck++;
            }
        });

        if(localStorage.getItem('cartItems') && freeItemCheck === 0){
            cartData = JSON.parse(localStorage.getItem('cartItems'));
            cartData.map((item) => {
                sumCart += (item.PDP_Price1 * item.qty);
            });
        }else{
            cartData = JSON.parse(localStorage.getItem('cartItemsNew'));
            cartData.map((item) => {
                sumCart += (item.PDP_Price1 * item.qty);
            });
        }

        let DeliveryData = {};
        if (localStorage.getItem('DeliveryData')) {
            DeliveryData = JSON.parse(localStorage.getItem('DeliveryData'));
        }

        let authData = {};
        if (localStorage.getItem('authData')) {
            authData = JSON.parse(localStorage.getItem('authData'));
        }

        var tax_amount = (this.state.taxProductTotalAmount/100) * 20;

        var grandtotal = (this.state.taxProductTotalAmount > 0 ? sumCart + tax_amount : sumCart);

        let payload = JSON.stringify({
            amount: Math.round(sumCart) * 100,
            subtotal: sumCart.toFixed(2),
            grandtotal: grandtotal.toFixed(2),
            cartData: cartData,
            DeliveryData: moment(DeliveryData.deliveryDate).format("DD-MM-YYYY"),
            authData: authData,
            PaymentMethod: 'A',
            tax_percentage: (this.state.taxProductTotalAmount > 0 ? '20' : 0),
            taxable_amount: this.state.taxProductTotalAmount,
            tax_amount: tax_amount.toFixed(2),
        });


        let URL = BaseUrl + "order";
        var numberOfAjaxCAllPending = 0;
        var timeInterval = '2000';
        var current = this;

        this.setState({alertPopup: false});

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        axios.post(URL, payload, { headers: { 'Content-Type': 'application/json', "Auth-Token": loginDetails.token}}).then(async (response) => {
            this.setState({alertPopup: false, disableButton: 0, orderPlacedStatus :true});
            numberOfAjaxCAllPending++;
            localStorage.removeItem('cartItems');
            localStorage.setItem('orderId', response.data.data.orderId);
            localStorage.setItem('payment', 'A');
            clearInterval(myInterval);

            if(response.data.data.orderId !==''){
              var myDate = new Date();
              var year = myDate.getFullYear();
              var month = myDate.getMonth() + 1;
              if(month <= 9)
              month = '0'+month;
              var day= myDate.getDate();
              if(day <= 9)
              day = '0'+day;
              var prettyDate = day +'/'+ month +'/'+ year+ ' ' + myDate.getHours() + ":"  
                + myDate.getMinutes();
              localStorage.setItem('order_placed_date', prettyDate);
              localStorage.setItem('delivery_date', moment(DeliveryData.deliveryDate).format("DD/MM/YYYY"));
            }

            window.location.href = '/thankyou';
        }).catch((err) => {
            numberOfAjaxCAllPending++;
            this.setState({alertPopup: false, orderPlacedStatus: false, viewInfoPayment: false});
            console.log(err);
        });


        var myInterval = setInterval(function() {
        if(numberOfAjaxCAllPending == 0){
          numberOfAjaxCAllPending++;
          current.setState({alertPopup: true, visibleAlert:false, delete_item_popup:false});
          timeInterval = '';
        }},timeInterval);

    }


    updateStateValue() {
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var cartTotal = 0;
        var subTotal = 0;

        cartItems.map(function (cartItem) {
          if(cartItem.product_type === 'Normal'){
            if (cartItem.qty > 0) {
                this.setState({ [cartItem.productNumber]: cartItem.qty });
                cartTotal += parseFloat(cartItem.PDP_Price1) * cartItem.qty;
                subTotal  += parseFloat(cartItem.PDP_Price1) * cartItem.qty;
            } else {
                this.setState({ [cartItem.productNumber]: 0 });
            }
          }

        }, this);

       var totalAmount = 0;
       var TaxAmount = 0;
       
        if(cartItems !=='' && cartItems !== null){
            cartItems.map((taxItem)=>{
                if(taxItem.productTaxVal > 0){
                  totalAmount += taxItem.PDP_Price1 * taxItem.qty;
                }
            });
        }

        if(totalAmount > 0){ 
          TaxAmount = (totalAmount/100)*20;  
          cartTotal = cartTotal + TaxAmount;
        }
        

        this.setState({cartSubTotal: this.priceFormat(subTotal), cartOriginalTotal: subTotal, cartTotal: this.priceFormat(cartTotal), taxProductTotalAmount: totalAmount,vatTaxAmount: TaxAmount });

        this.checkOfferProductQty();

    }


    checkOfferProductQty(){

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
            productToBeAdded = offerproductsList.productToBeAdded;
           // stringSplit = productToBeAdded.split(',');
        }
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        var removeProduct = this.state.removeProduct;

        if(offerproductsList !== ''){
         
         cartItemsLast.map((freeItem)=>{
          stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
           });
         });

        }

        this.setState({offerProductQty: offerProductLastQty});
    }
    
    increaseQty(e, item) {

        e.preventDefault();
    
        if(item.product_type === 'Free'){
         return false;
        }

        var timeInterval = '1000';
        var current = this;
        var element = document.getElementById("checkout-table-body");
        element.classList.add("checkout_qty_loader");

        this.setState({ loading: true, alertPopup:false, freeProductOpen:false });
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        // Update cart item quantity if already in cart
        var newitems = [];
        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'))) {

            newitems = cartItems.map((cartItem) =>
                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem,
                        qty: cartItem.qty + 1
                    }
                    : cartItem
            )

        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();
        this.getSeprateProducts();
        this.setState({ loading: false });

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

        var typeFree = 0;
        
        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
             typeFree = 1;
        }

        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }

        var offerProductQty = 0;

        if(stringSplit !==''){
         cartItemsNew.map((cartItem) => {
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            });
         });
        }

        var returnProductNumberNew = 0;
        if(stringSplit !==''){
         stringSplit.filter(function(value) {
            if(item.productNumber === value){
               returnProductNumberNew = value
            }
         });
        }

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;

         cartItemsNew.map((freeItem)=>{

              var increment = this.state.accountObjective1;
              var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;
              offerproductQtyRemaing = offerProductQty - calculatedTotal;
           }

          });

         if(typeFree === 0){

           offerproductQtyRemaing = offerProductQty;
         }

         localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
         localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        //console.log(typeFree, offerproductsList.productQtyToBeAdded, offerProductQty, returnProductNumberNew);
     
        if(typeFree == '0' && offerProductQty >= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductQty && returnProductNumberNew !== 0){
          this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }else if(typeFree == '0' && offerProductQty <= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductQty && returnProductNumberNew !== 0){
          this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }else if(typeFree == '1' && offerProductQty == this.state.accountObjective2 && offerProductQty > this.state.accountObjective1  && returnProductNumberNew !== 0){
             this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }

        if(offerProductQty !=='' && returnProductNumberNew !== 0){

            //this.freeProductQtyUpdateOnly(offerProductQty, 'decrease');
        } 

        if(typeFree == '1' && offerProductQty > this.state.accountObjective2 && returnProductNumberNew !== 0){

            var fourValue = this.state.accountObjective1;
            var fiveValue = this.state.accountObjective2;
            var retunrFour4 = this.checkIfMultiple(offerProductQty, fourValue);
            var retunrFour5 = this.checkIfMultiple(offerProductQty, fiveValue);

            if(retunrFour4 === true){
                this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
            }

            if(retunrFour5 === true){
                this.setState({checkedItems2: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
            }
        }

         var myInterval = setInterval(function() {
            timeInterval = '';
            element.classList.remove("checkout_qty_loader");
            clearInterval(myInterval);
          },timeInterval);
    }



    decreaseQty(e, item) {
        e.preventDefault();

        if(item.product_type === 'Free'){
         return false;
        }

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        // Update cart item quantity if already in cart
        var newitems = [];
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== ''){
           productToBeAdded = offerproductsList.productToBeAdded;
           //stringSplit = productToBeAdded.split(',');
        }

        var typeFree = 0;
        var rice_product = 0;
         var freeProductCount = 0;

        if(cartItems.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

    

        if(item.product_type === 'Free'){
            this.setState({common_alert_message: 'Are you sure you want to delete your free product?', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false });
            return false;
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;

        if(stringSplit !== ''){

         cartItems.map((cartItem) => {
          
           if(cartItem.product_type === 'Free'){
                    freeProductCount++;
            }

          if(this.state.freeProductDataFive.includes(cartItem.productNumber) === true && cartItem.product_type === 'Free'){

            rice_product = '6587';
           }

            stringSplit.filter(function(value) {

               if(value ===  item.productNumber){

                returnProductNumber = value;

               }

                if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){

                    previousofferProductQty += cartItem.qty;
                }
            });
          });

        }

        var decreaseNumber = item.qty - 1;

        var check_product_qty = previousofferProductQty - item.qty + decreaseNumber;

        if(rice_product !== 0 && typeFree == 1 && check_product_qty < this.state.accountObjective2){

          this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen: false,addtoCartTypeQty: decreaseNumber });
            return false;

         }

        if(rice_product == 0 && typeFree == 1 && check_product_qty < this.state.accountObjective1 ){

          this.setState({common_alert_message: ' If you reduce your cart quantity, it will clear your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen: false,addtoCartTypeQty: decreaseNumber });
            return false;
        }


        if(typeFree === 1 && previousofferProductQty == this.state.accountObjective1 && returnProductNumber !== 0){

            this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen: false,delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty: decreaseNumber});
            return false;

        }else if(typeFree === 1 && rice_product !== 0 && previousofferProductQty == this.state.accountObjective2 && returnProductNumber !== 0){

          this.setState({common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty: decreaseNumber});
            return false;
        }

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        if(stringSplit !==''){
          cartItemsLast.map((freeItem)=>{
          stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
           });
          });
        }

        cartItemsLast.map((freeItem)=>{

         var increment = this.state.accountObjective1;
         var increment1 = this.state.accountObjective2;


         if(freeItem.product_type === 'Free'){

           typeFree++;

          if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
            increment1 = this.state.accountObjective2;
            productFiveqty = freeItem.qty;
           }else{
            increment = this.state.accountObjective1;
            productFourqty += freeItem.qty;
          }


          totalCount = increment * productFourqty;
          totalCount1 = increment1 * productFiveqty;
          calculatedTotal = totalCount + totalCount1;
          offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
         }

       });

        if(returnProductNumber !== 0 && freeProductCount > 1 && offerproductQtyRemaing == 0){
           this.setState({decrease_alert_popup: true, decrease_alert_popup_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.',decreaseItem: item});
           return false;
        }

        var timeInterval = '1000';
        var current = this;
        var element = document.getElementById("checkout-table-body");
        element.classList.add("checkout_qty_loader");

        this.setState({ loading: true, alertPopup:false, freeProductOpen:false });

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'))) {

            if(item.product_type === 'Normal'){

            newitems = cartItems.map((cartItem) =>
                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem,
                        qty: cartItem.qty - 1
                    }
                    : cartItem
            )
            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();
            newitems = newitems.filter((cartItem) => cartItem.qty >= 1);

          }

        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();
        this.getSeprateProducts();

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'))) {

            if(item.product_type === 'Free'){

            newitems = cartItems.map((cartItem) =>
                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'
                    ? {
                        ...cartItem,
                        qty: cartItem.qty - 1
                    }
                    : cartItem
            )
            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();
            newitems = newitems.filter((cartItem) => cartItem.qty >= 1);

          }

        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();
        this.getSeprateProducts();

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        var offerProductQty = 0;
        var LastRiceProduct = 0;

        if(stringSplit !== ''){

            cartItemsNew.map((cartItem) => {
                if(cartItem.product_type === 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber)){
                    LastRiceProduct = cartItem.productNumber;
                }
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductQty += cartItem.qty;
                    }
                });
             });
        }

        var returnProductNumberNew = 0;

       if(stringSplit !== ''){
        stringSplit.filter(function(value) {
            if(item.productNumber === value){
               returnProductNumberNew = value
            }
        });
       }

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;

         cartItemsNew.map((freeItem)=>{


           var increment = this.state.accountObjective1;
           var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductQty - calculatedTotal;
           }

          });

         if(typeFree === 0){

           offerproductQtyRemaing = offerProductQty;
         }
         
         localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
         localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        if(typeFree == 0 && item.product_type == 'Normal' && offerProductQty <= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductQty && returnProductNumberNew !== 0){

            this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

        }else if(typeFree == 1 && item.product_type == 'Normal' && offerProductQty <= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductQty  && returnProductNumberNew !== 0){

            this.setState({checkedItems: new Array(localStorage.getItem("freeProductIds")), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});

        } else if(typeFree == 1 && item.product_type == 'Normal' && offerProductQty >= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductQty && LastRiceProduct === ''  && returnProductNumberNew !== 0){

            this.setState({checkedItems: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }

        if(offerProductQty !=='' && returnProductNumberNew !== 0){

            this.freeProductQtyUpdateOnly(offerProductQty);
        } 

        if(typeFree == '1' && offerProductQty > this.state.accountObjective2 && returnProductNumberNew !== 0){

            var fourValue = this.state.accountObjective1;
            var fiveValue = this.state.accountObjective2;
            var retunrFour4 = this.checkIfMultiple(offerProductQty, fourValue);
            var retunrFour5 = this.checkIfMultiple(offerProductQty, fiveValue);

        }

        this.setState({offerProductQty: offerProductQty});

        this.getSeprateProducts();

        var myInterval = setInterval(function() {
            timeInterval = '';
            element.classList.remove("checkout_qty_loader");
            clearInterval(myInterval);
           },timeInterval);

        this.setState({ loading: false });
    }

    checkIfMultiple(num1, num2) {
      return num1 % num2 === 0;
    }

    freeProductQtyUpdateOnly(offerProductQty){

        var freeProductList = this.state.freeProductData;
        var offerproductsList =  this.state.offerCombineProducts;
       
        var offerProductQty = offerProductQty;
        var divided_by_4 = offerProductQty / this.state.accountObjective1;
        var divided_by_5 = offerProductQty / this.state.accountObjective2;
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));

        var newitems = [];

        var freeProductCount = 0;

        cartItems.map((cartItem)=>{
            if(cartItem.product_type === 'Free'){
                freeProductCount++;
            }
        });

        if(freeProductCount === 1){

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && 
            this.state.freeProductDataFive.includes(cartItem.productNumber) ))) {

            var previousQtyFive = 0;

             cartItems.map((cartItem) =>{
                if(cartItem.product_type === 'Free'){
                    previousQtyFive = cartItem.qty;
                }
             });

             if(previousQtyFive  > firstNum5){

             newitems = cartItems.map((cartItem) =>

                this.state.freeProductDataFive.includes(cartItem.productNumber) && cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum5
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.getSeprateProducts();
              this.setState({freeProductQty: firstNum5});

             }
        }

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber) !== true ))) {

            var previousQty = 0;

             cartItems.map((cartItem) =>{
                if(cartItem.product_type === 'Free'){
                    previousQty = cartItem.qty;
                }
             });

            if(previousQty  > firstNum4){

             newitems = cartItems.map((cartItem) =>

                 cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum4
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.getSeprateProducts();
              this.setState({freeProductQty: firstNum4});
           }

         }

       }
    
    }

    freeProductQtyUpdate(offerProductQty){

        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerCombineProducts;
        var stringSplit = this.state.offerCombineProducts;

        var offerProductQty = offerProductQty;
        var divided_by_4 = offerProductQty / this.state.accountObjective1;
        var divided_by_5 = offerProductQty / this.state.accountObjective2;
        var firstNum4 = parseInt(divided_by_4)
        var firstNum5 = parseInt(divided_by_5)

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));

        var newitems = [];
        var freeProductCount = 0;

        cartItems.map((cartItem)=>{
            if(cartItem.product_type === 'Free'){
                freeProductCount++;
            }
        });

        if(freeProductCount === 1){

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && 
            this.state.freeProductDataFive.includes(cartItem.productNumber) ))) {

             newitems = cartItems.map((cartItem) =>

                this.state.freeProductDataFive.includes(cartItem.productNumber) && cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum5
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.getSeprateProducts();
              this.setState({freeProductQty: firstNum5});
        }

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.product_type == 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber) !== true ))) {

             newitems = cartItems.map((cartItem) =>

                 cartItem.product_type === 'Free'
                    ? {
                        ...cartItem, 
                        qty:  firstNum4
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.getSeprateProducts();
              this.setState({freeProductQty: firstNum4});
        }

        var element = document.getElementById("checkout-table-body");
        element.classList.remove("checkout_qty_loader");

    }else if(freeProductCount > 1){

        var newitemsLast = [];
        newitemsLast = cartItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
        localStorage.setItem('cartItems', JSON.stringify(newitemsLast));
        this.updateStateValue();
        this.getSeprateProducts();

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;
        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

        if(stringSplit !== ''){
            cartItemsNew.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

         cartItemsNew.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){

           offerproductQtyRemaing = offerProductQty;
         }

        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        //console.log(offerproductQtyRemaing, offerproductQtyRemaing);

        if(offerproductQtyRemaing > 0 ){

        this.setState({freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }
     }

    }

    addFreeProduct(event,checkedprod,freeProduct, productValue, freeProductNew, checkedState){

       event.preventDefault();
       document.getElementById("alert_message").innerHTML = '';
       
       if(checkedprod.length > 0){
        this.setState({checkedItems:checkedprod});
       }
   
       var condition = 0;
       var inputCount = 0;

        productValue.map((value, index)=>{
           inputCount += value.qty;
        });

        if(inputCount > 0){

        var freeProductList = freeProduct;
        var newitems_new = [];
        var cartItemsList = JSON.parse(localStorage.getItem("cartItems"));
        var freeItems = [];

         freeProductList.data.map((data, index)=>{

            var oldprice = '';
            var productDescriptionText = '';
            var newitems = [];
            var current = this;
            this.updateStateValue();
            var freeQty = 0;

             var newitems = [];

            this.updateStateValue();
            this.getSeprateProducts();

            if(condition === 0){

               var cartItems = JSON.parse(localStorage.getItem("cartItems"));
                   oldprice = data.PDP_Price1;
                   data.PDP_Price1 = '0';
                   productDescriptionText = data.productDescription;
                   data.productDescription = productDescriptionText;

             if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === data.productNumber && cartItem.product_type === 'Free'))) {


              productValue.map((freeItem)=>{
                    if(freeItem.pid === data.productNumber){
                        freeQty = freeItem.qty;
                        freeItems.push(freeItem.pid);
                    }
                });

                newitems = cartItems.map((cartItem) =>
                    cartItem.productNumber === data.productNumber
                        ? {
                            ...cartItem,
                            qty: freeQty
                        }
                        : cartItem
                )

               } else {

               productValue.map((freeItem)=>{
                    if(freeItem.pid === data.productNumber){
                        freeQty = freeItem.qty;
                        freeItems.push(freeItem.pid);
                    }
                });


                if (cartItems !== null) {
                    newitems = [...cartItems, { ...data, qty: freeQty, product_type: 'Free' }]
                } else {

                    newitems = [{ ...data, qty: freeQty, product_type: 'Free' }]
                }

              }
 
            newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
            localStorage.setItem('cartItems', JSON.stringify(newitems));
            this.updateStateValue();
            this.getSeprateProducts();
            data.PDP_Price1 = oldprice;
            data.productDescription = productDescriptionText;
            localStorage.setItem('freeProductIds', data.productNumber);
            this.setState({ viewFreeProductInfo: '', freeProductOpen:false,freeProductIds: (this.state[data.productNumber] > 0 ? '' :  data.productNumber)});

            }

           });


        localStorage.setItem('freeProductIdsNew', freeItems);

        this.setState({ freeProductIds: freeItems});

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductQty = 0;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit =  this.state.offerCombineProducts;

        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        } 
        
        if(stringSplit !== ''){
         cartItemsNew.map((cartItem) => {
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            });
         });
        } 

         }else{
          document.getElementById("alert_message").innerHTML = 'Please select the minimum one item';
         }
    }

     checkProductDelete(item){

        var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== ''){
           productToBeAdded = offerproductsList.productToBeAdded;
          //stringSplit = productToBeAdded.split(',');
        }
        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;
        var offerProductLastQty = 0;
        var typeFree = 0;

        var removeProduct = this.state.removeProduct;

        if(offerproductsList !== ''){
         
         cartItemsLast.map((freeItem)=>{

         stringSplit.filter(function(value) {
            if(freeItem.productNumber === value){
                offerProductLastQty += freeItem.qty;
            }
          });

         });

        }

        cartItemsLast.map((freeItem)=>{

         var increment = this.state.accountObjective1;
         var increment1 = this.state.accountObjective2;

         if(freeItem.product_type === 'Free'){

           typeFree++;

          if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
            increment1 = this.state.accountObjective2;
            productFiveqty = freeItem.qty;
          }else{
            increment = this.state.accountObjective1;
            productFourqty += freeItem.qty;
          }

          totalCount = increment * productFourqty;
          totalCount1 = increment1 * productFiveqty;
          calculatedTotal = totalCount + totalCount1;

          offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
         }

       });

        if(offerproductQtyRemaing > 0){
            var remaingQty = offerproductQtyRemaing;
            var checkRemaing = offerProductLastQty - item.qty;
            if(checkRemaing >= calculatedTotal){
                return checkRemaing;
            }else{
                return 0;
            }

        }else{
            return 0;
        }
     }


    deleteProduct(item) {

      this.setState({alertPopup:false,freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false});

      if(item.product_type === 'Normal'){

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        } 
        
        var typeFree = 0;
        var rice_product = 0;
        var existFree = 0;
        var freeProductCount = 0;
        var freeProductQtyCount = 0;

        if(cartItems.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;
        var previousQty = 0;
        var oldRice = '';
        
         cartItems.map((cartItem) => {

          if(cartItem.productNumber === item.productNumber){
             previousQty = cartItem.qty;
           }

          if(cartItem.product_type === 'Free'){
            existFree = '1';
            freeProductCount++;
            freeProductQtyCount += cartItem.qty;
          }
 
          if(this.state.freeProductDataFive.includes(cartItem.productNumber) && cartItem.product_type === 'Free'){

                rice_product = '6587';
          }

          if(stringSplit !== ''){

               stringSplit.filter(function(value) {

                if(value ===  item.productNumber){
                    returnProductNumber = value;
                }

                if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                    previousofferProductQty += cartItem.qty;
                }
             });

          }

         });

       var CheckFreeProductDelete = this.checkProductDelete(item);

        // console.log(returnProductNumber, freeProductCount, freeProductQtyCount, CheckFreeProductDelete);

         if(returnProductNumber !== 0 && freeProductQtyCount == 1 && freeProductCount === 1 && CheckFreeProductDelete === 0){

            this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'If you reduce your cart quantity, it will clear your FREE products.'});
            return false;
        }

        if(returnProductNumber !== 0 && freeProductCount === 1 && CheckFreeProductDelete === 0){
           this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'Are you sure you want to delete this item?'});
           return false;
        }

        if(returnProductNumber !== 0 && freeProductCount > 1 && CheckFreeProductDelete === 0){
           this.setState({delete_item_alert_popup: true, delete_single_Item: item, delete_item_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.'});
           return false;
        }

        var check_product_qty = previousofferProductQty - previousQty;

          if(rice_product !== 0 && check_product_qty < this.state.accountObjective2 && returnProductNumber !== 0){

             this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:0});

              return false;
         }

          if(existFree == '1' && rice_product == 0 && check_product_qty < this.state.accountObjective1 && returnProductNumber !== 0){

             this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', common_alert_popup: true, removeFreeProduct: item, freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false, addtoCartTypeQty:0});
             
              return false;
            
           }

          if(existFree === 1 && previousofferProductQty == this.state.accountObjective1 && returnProductNumber !== 0){

          this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', delete_item_popup_free: true, delete_item_popup_free_message: 'If you reduce your cart quantity, which will remove your free product?', removeProduct: item, freeProductOpen:false});

          return false;

         }else if(existFree === 1 && rice_product !== 0 && previousofferProductQty == this.state.accountObjective2 && returnProductNumber !== 0){

          this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_message: 'If you reduce your cart quantity, it will clear your FREE products and you will need to reselect your FREE products.', delete_item_popup_free: true, delete_item_popup_free_message: 'If you reduce your cart quantity, which will remove your free product?', removeProduct: item, freeProductOpen:false });
            return false;

         }else{

           if(returnProductNumber !== 0){
           this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_popup: false, delete_item_popup_free:false, delete_item_popup: true, removeProduct: item, freeProductOpen:false});
           return false;

          }else{

           this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_popup: false, delete_item_popup_free:false, delete_item_popup: true, removeProduct: item, freeProductOpen:false});
            return false;
          }
      }

     }else{

          this.setState({loading: false, reloadCart: false, alertPopup:false, common_alert_message: 'Are you sure you want to delete your free product?', common_alert_popup: true, removeFreeProduct: item, clear_cart: false, delete_item_popup: false, delete_item_popup_free:false, freeProductOpen:false});
            return false;
      }

   
    }

    clearSingleItem(){

      this.setState({alertPopup:false,freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false});

        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== ''){
         //productToBeAdded = offerproductsList.productToBeAdded;
           stringSplit = productToBeAdded.split(',');
        } 
        
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];
        var freeProductExist = '0';
        var offerProductQty = 0;
       
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });

         var returnProductNumberNew = 0;
         var current = this;

         if(stringSplit !== ''){
         stringSplit.filter(function(value) {
                if(current.state.removeProduct.productNumber === value){
                    returnProductNumberNew = value;
                }
         });
         }

        var checkFreeItems = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductQty = 0;

        if(stringSplit !== ''){
          checkFreeItems.map((cartItem) => {
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            })
         });
        }

        var localCart = [];

        if (cartItems !== null && cartItems.some((cartItem) => cartItem.productNumber === this.state.removeProduct.productNumber )) {

            var duplicateProduct = 0;
        
            localCart = cartItems.map((cartItem) =>

                cartItem.productNumber === this.state.removeProduct.productNumber && cartItem.product_type === this.state.removeProduct.product_type
                    ? {
                        ...cartItem, 
                        qty: 0,
                    }
                    : cartItem
                
                );

              localStorage.setItem('cartItems', JSON.stringify(localCart));
              this.updateStateValue();
              localCart = localCart.filter((cartItem) => cartItem.qty >= 1);

             this.setState({ [this.state.removeProduct.productNumber]: 0, clear_cart: false, delete_item_popup: false});
        }

        localStorage.setItem('cartItems', JSON.stringify(localCart));
        this.updateStateValue();
        this.getSeprateProducts();
        this.setState({loading: false, common_alert_popup: false,   delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:false, freeProductOpen:false});

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductLastQty = 0;
        var freeProductExistLast = '';
        var LastRiceProduct = 0;

        cartItemsFinal.map((cartItem) => {
            if(cartItem.product_type === 'Free'){
                freeProductExistLast++;
            }

            if(cartItem.product_type === 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber)){

                LastRiceProduct = cartItem.productNumber;
            }

            if(stringSplit !== ''){
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductLastQty += cartItem.qty;
                }
            });
           }

        });

        if(this.state.removeProduct.product_type === 'Free'){

            localStorage.setItem('freeProductIds', '');
        }

         if(freeProductExistLast === '' && offerProductLastQty <= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({loading: false, common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

         }else if(freeProductExistLast === '' && offerProductLastQty <= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({loading: false, common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

         }else if(freeProductExistLast !== '' && LastRiceProduct == '0' && offerProductLastQty <= this.state.accountObjective2 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({loading: false, common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

         }else if(offerProductLastQty <= this.state.accountObjective1 && this.state.accountObjective1 <= offerProductLastQty && returnProductNumberNew !== 0){

            this.setState({loading: false, common_alert_popup: false,  clear_cart: false, delete_item_popup: false, removeProduct: [],delete_item_popup_free: false, freeProductOpen:true, checkedItems: new Array(localStorage.getItem("freeProductIds")), offerProductQty: offerProductLastQty});

        }

        if(offerProductLastQty !== '' && returnProductNumberNew !== 0 ){

          this.freeProductQtyUpdate(offerProductLastQty);

        }

    }


    clearSingleItemFree(){

        this.setState({alertPopup:false,freeProductOpen:false, delete_item_popup_free: false, delete_item_popup: false});

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var freeProductList = this.state.freeProductData;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        
        if(offerproductsList !== '' && offerproductsList !==''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }

        var newitems = [];
        var freeProductExist = '0';
        var offerProductQty = 0;
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });

       var checkFreeItems = JSON.parse(localStorage.getItem("cartItems"));
       var offerProductQty = 0;

       if(stringSplit !== ''){
        checkFreeItems.map((cartItem) => {
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductQty += cartItem.qty;
                }
            })
         });
        }
        
        if(freeProductExist === 1 && offerProductQty == this.state.accountObjective1){

           freeProductList.data.map((data, index)=>{
           if(checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {
                newitems = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
                localStorage.setItem('cartItems', JSON.stringify(newitems));
             }

         });

         this.updateStateValue();
         this.getSeprateProducts();

        }else if(freeProductExist === 1 && offerProductQty == this.state.accountObjective2){

            freeProductList.data.map((data, index)=>{

              if (checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

                 newitems = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free' && this.state.freeProductDataFive.includes(cartItem.productNumber) !== true));

                localStorage.setItem('cartItems', JSON.stringify(newitems));

              }

            });

        }

        var newitems_last = [];

        var cartItemsLatest = JSON.parse(localStorage.getItem("cartItems"));

        if (cartItemsLatest !== null && cartItemsLatest.some((cartItem) => cartItem.productNumber === this.state.removeProduct.productNumber)) {

            newitems_last = cartItemsLatest.filter((cartItem) => cartItem.productNumber !== this.state.removeProduct.productNumber);
            this.setState({ [this.state.removeProduct.productNumber]: 0, delete_item_popup: false});
        }

        localStorage.setItem('cartItems', JSON.stringify(newitems_last));

        this.updateStateValue();
        this.getSeprateProducts();

        this.setState({common_alert_popup: false, delete_item_popup: false, removeProduct: [], delete_item_popup_free: false});

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductLastQty = 0;

        if(stringSplit !== ''){

          cartItemsFinal.map((cartItem) => {
            stringSplit.filter(function(value) {
                if(cartItem.productNumber === value){
                    offerProductLastQty += cartItem.qty;
                }
            })
          });

        }

        if(offerProductLastQty >= this.state.accountObjective1){
         this.setState({checkedItems: localStorage.getItem("freeProductIds"), freeProductOpen:true, offerProductQty: offerProductLastQty});
       }


        if(offerProductQty !== ''){
          this.freeProductQtyUpdate(offerProductQty);
        }
    }


     freeProductClear(){

        var removeFreeProduct = this.state.removeFreeProduct

        this.removeFreeProduct(this.state.removeFreeProduct);

        this.setState({
            common_alert_popup: false,
        });

      }

      removeFreeProduct(item){

       var cartItems = JSON.parse(localStorage.getItem("cartItems"));
       var freeProductList = this.state.freeProductData;
       var offerproductsList = this.state.offerproducts;
       var productToBeAdded = '';
       var stringSplit = this.state.offerCombineProducts;
       
       if(offerproductsList !== '' && offerproductsList !==''){
          productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }
       
       this.setState({ loading: true, reloadCart: false });

       var newitems = [];

       var newitemsTest = [];

       var returnProductNumberNew = 0;

       if(stringSplit !== ''){

          stringSplit.filter(function(value) {

            if(value ===  item.productNumber){

                returnProductNumberNew = value;

            }

          });
       }

       if(item.product_type === 'Free'){

       if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'))) {

        if(item.product_type === 'Free'){

         newitems = cartItems.map((cartItem) =>

            cartItem.productNumber === item.productNumber && cartItem.product_type === 'Free'
                ? {
                    ...cartItem, 
                    qty: 0
                }
                : cartItem
         );

          localStorage.setItem('cartItems', JSON.stringify(newitems));
          localStorage.setItem('freeProductIds', '');
          this.updateStateValue();
          newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
        
        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));
        localStorage.setItem('freeProductIds', '');
        this.updateStateValue();
        this.getSeprateProducts();
         this.setState({ reloadCart: true, loading: false, common_alert_message: '', common_alert_popup: false, removeFreeProduct: '' });
        }

      }else{


        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'))) {

            if(item.product_type === 'Normal'){

            var product_qty = this.state.addtoCartTypeQty;

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: (product_qty !== '' ? product_qty : cartItem.qty - 1 )
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
            
             }

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              this.updateStateValue();
              this.getSeprateProducts();

            var newCartItemsLast = [];

            if (this.state.addtoCartTypeQty == '1' && cartItems !== null && cartItems.some((cartItem) => cartItem.productNumber === item.productNumber)) {

                // newCartItemsLast = cartItems.filter((cartItem) => cartItem.productNumber !== item.productNumber);
                //  localStorage.setItem('cartItems', JSON.stringify(newCartItemsLast));
                //  this.updateStateValue();
                //  this.getSeprateProducts();
                //  this.setState({addtoCartTypeQty: 0});
            }

        }

        var freeProductExist = '0';
        cartItems.map((cartItem) =>{
         if(cartItem.product_type === 'Free'){
             freeProductExist++;
            }
         });

      
        var checkFreeItems = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductQty = 0;

        if(stringSplit !== ''){

         checkFreeItems.map((cartItem) => {

            stringSplit.filter(function(value) {

                if(cartItem.productNumber === value){

                    offerProductQty += cartItem.qty;
                }
            });
          });

         }
            
         if(freeProductExist == 1 && offerProductQty < this.state.accountObjective1){

          freeProductList.data.map((data, index)=>{

          if (checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

            if(this.state.accountObjective1 > offerProductQty){

            newitems = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitems));

            } 
          }

         });

         this.updateStateValue();
         this.getSeprateProducts();

         this.setState({checkedItems: localStorage.getItem("freeProductIds"), freeProductOpen:false, offerProductQty: offerProductQty});
         localStorage.setItem('freeProductIds', '');

        }else if(freeProductExist == 1 && offerProductQty == this.state.accountObjective1){

        var newitemsLast = [];

         freeProductList.data.map((data, index)=>{

          if (checkFreeItems !== null && checkFreeItems.some((cartItem) => cartItem.productNumber === data.productNumber)) {

            newitemsLast = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLast));

            this.updateStateValue();
            this.getSeprateProducts();

          }

        });

         localStorage.setItem('freeProductIds', '');
         var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
            var offerproductQtyRemaing = 0;
            var productFourqty  = 0;
            var productFiveqty  = 0;
            var totalCount = 0;
            var totalCount1 = 0;
            var calculatedTotal = 0;
            var offerProductLastQty = 0;
            var typeFree = 0;


           cartItemsLast.map((freeItem)=>{

             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQty += freeItem.qty;
                }
              });

            });

            cartItemsLast.map((freeItem)=>{

             var increment = this.state.accountObjective1;
             var increment1 = this.state.accountObjective2;

             if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }


              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }

    
        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

         if(returnProductNumberNew !== 0){
            this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing});
          }

        }

        var cartItemsLastFinal = JSON.parse(localStorage.getItem("cartItems"));
        var NormalProductCheck = 0;

        cartItemsLastFinal.map((freeItemLast)=>{
            if(freeItemLast.product_type === 'Normal'){
                NormalProductCheck++;
            }
        });

        var newitemsLastFinal = [];

        if(NormalProductCheck === 0){
            newitemsLastFinal = checkFreeItems.filter((cartItem) => (cartItem.product_type !== 'Free'));
            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));
        }

        localStorage.setItem('freeProductIds', '');
        this.getSeprateProducts();
        this.setState({ reloadCart: false, loading: false });
        var element = document.getElementById("checkout-table-body");
        element.classList.remove("checkout_qty_loader");
     }

    }


    freeProductPopupOpen(e){

        e.preventDefault();

        this.setState({freeProductAlert: false});
        localStorage.removeItem('reorder_free_product_exist');

        var cartItemsFinal = JSON.parse(localStorage.getItem("cartItems"));
        var offerProductLastQty = 0;
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;

        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         //stringSplit = productToBeAdded.split(',');
        }
        
        if(stringSplit !== ''){
            cartItemsFinal.map((cartItem) => {
                stringSplit.filter(function(value) {
                    if(cartItem.productNumber === value){
                        offerProductLastQty += cartItem.qty;
                    }
                })
             });
        }

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));

        var typeFree = 0;
            
        if(cartItemsNew.some((cartItem) => cartItem.product_type === 'Free')) {
            typeFree = 1;
        }

        let prodlist = this.state.freeProductData.data.map(prd=>{return ({pid:prd.productNumber,qty:0})});

        var offerproductQtyRemaing = 0;
        var productFourqty  = 0;
        var productFiveqty  = 0;
        var totalCount = 0;
        var totalCount1 = 0;
        var calculatedTotal = 0;


         cartItemsNew.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

           if(freeItem.product_type === 'Free'){

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });


         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }

        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        this.setState({freeProductOpen:true, offerProductQty:offerProductLastQty, productValueIndex: prodlist, offerproductQtyRemaing: offerproductQtyRemaing});
    }


    priceFormat(price) {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
    }

    payNow(e) {

        if (this.state.payBool) {
            this.setState({ payBool: false });
            this.setState({alertPopup: false});
            localStorage.removeItem("DeliveryData");
        }
        else {
            this.setState({alertPopup: false});
            var elems = document.getElementsByClassName('modal-pay');
            for (var i=0;i<elems.length;i+=1){
              elems[i].style.display = 'block';
            }

            var checkBox = document.getElementById('chkbox');
            var freeItemCheck = 0;
            var cartDetails = JSON.parse(localStorage.getItem("cartItems"));

             cartDetails.map((cartItem)=>{
                if(cartItem.product_type === 'Free'){
                    freeItemCheck++;
                }
             });

            var reorder_free_product_exist = localStorage.getItem('reorder_free_product_exist');

            if(reorder_free_product_exist == '1' && freeItemCheck == 0){
                this.setState({freeProductAlert: true});
                return false;
            }

            let DeliveryData = {};
            DeliveryData['deliveryDate'] = this.state.deliveryDate;
            localStorage.setItem('DeliveryData', JSON.stringify(DeliveryData));

            if (this.state.deliveryDate === "" || this.state.deliveryDate === null) {
                this.setState({ deliveryDateErrMsg: 'This field is required' });
                window.scrollTo(500, 0);
            } else if (!checkBox.checked) {
                this.setState({ checkboxErrMsg: 'Please accept the Terms & Conditions, Privacy Policy to proceed with your order' });
            }else if (this.state.cartOriginalTotal < this.state.settingsList.minimumOrderAmount) {
                 this.setState({ minmumAmountError: true });
                 return false;
             /*else if (this.state.deliveryTime === "") {
                 this.setState({ deliveryTimeErrMsg: 'Field is required' });
             }*/
            }else if (this.orderDateChecking() == 'No') {
                this.setState({ uktimeerror: false });
               // return false;
            } else {

                //DeliveryData['deliveryTime'] = this.state.deliveryTime;
                var ukDate = new Date();
                var ukCurretTime = ukDate.toLocaleString('en-GB', { hour: '2-digit',   hour12: false, timeZone: 'Europe/London' });
                var currentDate = (ukCurretTime < 14 ? new Date(new Date().getTime() + (2 * 24 * 60 * 60 * 1000)):new Date(new Date().getTime() + (3 * 24 * 60 * 60 * 1000)));
                var currentDateFormat = moment(currentDate).format("DD-MM-YYYY");
                // console.log(currentDateFormat, 'currentDateFormat');
                this.setState({ deliveryDateErrMsg: '', checkboxErrMsg: "" });
                //  this.setState({ deliveryTimeErrMsg: '' });
                this.checkoutItemsRearrange();
                this.setState({ payBool: true, paymentmodevalue: 'Online' });
            }

        }

    }

    payLater() {

        let authData = {};
        if (localStorage.getItem('authData')) {
            authData = JSON.parse(localStorage.getItem('authData'));
        }

        let cartData = [];
        let sumCart = 0;
        let sumCartTotal = 0;
        let cartDetails  = JSON.parse(localStorage.getItem('cartItems'));
        var freeItemCheck = 0;
        var vatProductCheck = 0;

         cartDetails.map((cartItem)=>{
            if(cartItem.product_type === 'Free'){
                freeItemCheck++;
            }
            if(cartItem.productTaxVal > 0){
                vatProductCheck++;
            }
          });

        //if(localStorage.getItem('cartItems') && freeItemCheck === 0){
               // }else{
        //     cartData = JSON.parse(localStorage.getItem('cartItemsNew'));
        //     cartData.map((item) => {
        //         sumCart += (item.PDP_Price1 * item.qty);
        //     });
        // }

         cartData = JSON.parse(localStorage.getItem('cartItems'));
         cartData.map((item) => {
            sumCart += (item.PDP_Price1 * item.qty);
         });
        
        var limitAmount = authData.accountCreditLimit;

        if(limitAmount > 0){

            limitAmount = limitAmount;
        }
        
        if (this.state.payBool) {
            this.setState({ payBool: false });
            localStorage.removeItem("DeliveryData");
        }else {

            var checkBox = document.getElementById('chkbox');
            this.setState({alertPopup: false, delete_item_popup:false});

            var reorder_free_product_exist = localStorage.getItem('reorder_free_product_exist');

            if(reorder_free_product_exist == '1' && freeItemCheck == 0){
                this.setState({freeProductAlert: true});
                return false;
            }
    
            let DeliveryData = {};
            DeliveryData['deliveryDate'] = this.state.deliveryDate;
            localStorage.setItem('DeliveryData', JSON.stringify(DeliveryData));

            if (this.state.deliveryDate === "" || this.state.deliveryDate === null) {
                this.setState({ deliveryDateErrMsg: 'This field is required' });
                window.scrollTo(500, 0);
                this.setState({visibleAlert:false, delete_item_popup:false});
            }else if (!checkBox.checked) {
                this.setState({ checkboxErrMsg: 'Please accept the Terms & Conditions, Privacy Policy to proceed with your order' });
                this.setState({visibleAlert:false, delete_item_popup:false});
            }else if (this.state.cartOriginalTotal < this.state.settingsList.minimumOrderAmount) {
                 this.setState({ minmumAmountError: true });
                 return false;
            }else if (Number(sumCart) > Number(limitAmount)) {
                 this.setState({ creditLimitError: true });
                 return false;
            }else if (this.orderDateChecking() == 'No') {
               

                this.setState({ uktimeerror: true });
                return false;
            }else {

                this.setState({ deliveryDateErrMsg: '' });
                this.checkoutItemsRearrange();
                this.setState({visibleAlert:true, delete_item_popup:false});

                // if (window.confirm("Are you sure do you want to place order without online payment?") === true) {
                //     this.PlaceOrder();
                // }



                this.setState({alertPopup: false});
            }

        }

    }

    payLaterOrder(event){

        event.preventDefault();
        this.setState({alertPopup: false, paymentmodevalue: 'Cash'});

        this.setState((prevState, props) => ({
            disableButton: prevState.disableButton + 1
        })); 

        this.checkoutItemsRearrange();

        if(this.state.disableButton === 0){

          this.setState({viewInfoPayment: true, visibleAlert: false});

          this.PlaceOrder();
          return false;
        }
    }


    checkoutItemsRearrange(){

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));

        var newitems = [];
      
        var count = 0;
        var newProductPrice = 0;

         cartItems.map((cartItem)=>{

            if(cartItem.product_type === 'Free'){

                cartItem.productDescription = cartItem.productDescription +' - '+ 'FREE';
            }

            newitems.push(cartItem);

          });

          count++;

         var insertItems = JSON.stringify(newitems);
         localStorage.setItem('cartItemsNew', insertItems);
    }

    deleteCart(event, index) {

        let tempArrProducts = [];
        tempArrProducts = this.state.tempProducts;
        let arr = [];

        tempArrProducts.map((item, i) => {
            if (i !== index) {
                arr.push(item);
            }
        });

        this.setState({ products: arr });
        this.setState({ tempProducts: arr });

        if (arr.length > 0) {
            localStorage.removeItem('cartItems');
            localStorage.setItem('cartItems', JSON.stringify(arr));
        }else {
            localStorage.removeItem('cartItems');
            window.location.href = '/home';
        }
    }

    setStartDate(date) {
        this.timeSlot(date);
    }

    timeSlot(date) {

        let currentTime = moment(this.state.startDate).format("HH:mm");
        let openCurrentTime;

        let todayDate = moment(new Date()).format("YYYY-MM-DD");
        let startDate = moment(date).format("YYYY-MM-DD");

        if (startDate === todayDate) {
            let curtime = currentTime.split(":");
            if (curtime[0] > "09") {
                openCurrentTime = currentTime;
            }
            else {
                openCurrentTime = "09:00";
            }
        } else {
            openCurrentTime = "09:00";
        }

        let x = {
            slotInterval: 60,
            openTime: openCurrentTime,
            closeTime: '24:00'
        };

        let startTime = moment(x.openTime, "hh:00 A");
        let endTime = moment(x.closeTime, "hh:00 A");
        let allTimes = [];
        while (startTime < endTime) {
            allTimes.push(startTime.format("hh:mm A"));
            startTime.add(x.slotInterval, 'minutes');
        }

        let result;
        let timeArr = [];
        if (allTimes.length > 0) {
            result = allTimes.reduce(function (acc, curr, index) {
                if (index % 2) {
                    if (timeArr.length < 1) {
                        timeArr.push(acc + " - " + curr);
                    }
                    else {
                        timeArr.push(moment(acc, "hh:00 A").add(-1, "hour").format("hh:mm A") + " - " + moment(curr, "hh:00 A").add(-1, "hour").format("hh:mm A"));
                    }
                    acc = 0
                }
                else
                    acc = curr;
                return acc;
            }, 0);
        }

        this.setState({ TimeSlot: timeArr });

    }

    deliveryDateChange(value) {
        this.setState({
            deliveryDate: value
        });
        this.timeSlot(value);
        // this.setState({ deliveryTimeErrMsg: '' });
        this.setState({ deliveryDateErrMsg: '', alertPopup:false });
    }

    deliveryTimeChange(event) {
        this.setState({
            deliveryTime: event.target.value
        });
        this.setState({ deliveryDateErrMsg: '' });
        this.setState({ deliveryTimeErrMsg: '' });
    }


    dynamicSort(property) {
        var sortOrder = 1;

        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a,b) {
            if(sortOrder == -1 && b[property] !== null){
                return b[property].localeCompare(a[property]);
            }else if(a[property] !== null){
                return a[property].localeCompare(b[property]);
            }        
         }
    }

    getSeprateProducts() {

        let products = JSON.parse(localStorage.getItem("cartItems"));
        products.sort(this.dynamicSort("ProductGroup"));

        var freeItemCount = 0;
        products.map((free)=>{
            if(free.product_type === 'Free'){
                freeItemCount++;
            }
        });

        if (products.length < 1) {
            window.location.href = '/checkout/pizza';
        }
        let categories = [];

        products.map((item) => {
            if (!categories.includes(item.categoryId))
                categories.push(item.categoryId);
        });

       var productGroupList = [];

        products.map((item) =>{

            if(item.ProductGroup !== '' && item.ProductGroup !== null ){

                productGroupList.push(item.ProductGroup);
            }
        });

        this.setState({ categories: categories.sort()})

        let categoryProducts = [];
        let categoryProductsFree = [];
        categories.map((item) => {

            let productCat = [];
            let productCatFree = [];
            products.map((product) => {
                if (item === product.categoryId && product.product_type === 'Normal'){
                    productCat.push(product);
                }

                if (item === product.categoryId && product.product_type === 'Free'){
                    productCatFree.push(product);
                }

            });

            if(productCat.length > 0){
               var  newproductCat = this.groupBy(productCat, 'ProductGroup');
               categoryProducts.push({ [item]: newproductCat }); 
            }
            
            categoryProductsFree.push({ [item]: productCatFree });
        });

        this.setState({ categoryProducts: categoryProducts, freeItemCount: freeItemCount, categoryProductsFree: categoryProductsFree });
        this.updateStateValue();
    }


    groupBy(objectArray, property) {
        return objectArray.reduce((acc, obj) => {
            const key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            // Add object to list for given key's value
            acc[key].push(obj);
            return acc;
        }, {});
    }


    highlightAllergens(str){

     this.state.allergens.forEach((substr) => {
        var strRegExp = new RegExp("\\b"+ substr +"\\b","ig");
            str = str.replace(strRegExp, '<strong>' + substr + '</strong>');
        })

        return <div dangerouslySetInnerHTML={{ __html: str }} />
    }


    hightLightIngredients(str){

       this.state.ingredientsHigh.forEach((substr) => {
            var strRegExp = new RegExp("\\b"+ substr +"\\b","ig");
            str = str.replace(strRegExp, '<strong>' + substr + '</strong>');
        });

        return <div dangerouslySetInnerHTML={{ __html: str }} />
    }

    handlePopup = (e, item) => {

        this.setState({alertPopup: false, freeProductOpen: false});

        let viewInfo = <Popup
            extClass="info-poup show"
            closebtn={<><span onClick={() => this.setState({ viewInfo: "" })} className='close'></span></>}
            headMoreTxt={
                <>
                    <div className="order-top">
                        <h4><span>{item.productDescription} - {item.productNumber}</span></h4>
                    </div>
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="info-bdy">

                       {item.packageSize !== null && item.packageSize !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Unit of Sale</span></h5>
                                    <p>{item.packageSize}
                                    </p>
                                </div>
                            </div>
                        }

                        {item.productIngredient !== null && item.productIngredient !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Ingredients</span></h5>
                                    <p>{this.hightLightIngredients(item.productIngredient)}</p>
                                </div>
                            </div>
                        }
                        {item.productSpec !== null && item.productSpec !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Product Specification</span></h5>
                                    <p>
                                        <a target="_blank" href={item.productSpec} >Click here </a> for Information on ingredients not included in the 14 allergens, nutritional values, usage instructions and storage/shelf life
                                    </p>
                                </div>
                            </div>
                        }
                        {item.productUSP !== null && item.productUSP !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Allergens</span></h5>
                                    <p>
                                        {(item.productUSP === 'No Allergens' || item.productUSP === 'No Allegens'  || item.productUSP === 'No Allegen') ? "Doesn't contain any of the 14 most potent and prevalent allergens required to be declared by food law" : this.highlightAllergens(item.productUSP)}

                                    </p>
                                </div>
                            </div>
                        }
                        {item.productDiet !== null && item.productDiet !== "" &&
                            <div className="info-item">
                                <div className="info-innr">
                                    <h5><span>Diet Suitablity</span></h5>
                                    <p>
                                        {item.productDiet}
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                </>
            }
        />

        this.setState({ viewInfo: viewInfo });
    }


    handleImage = (e, item) => {

        console.log(item, 'item');


        this.setState({alertPopup:false, freeProductOpen:false});

        let viewdddImage = "";

        viewdddImage = <Popup
            extClass="prt-poup prt-img-poup show"
            closebtn={<><span onClick={() => this.setState({ viewImage: "" })} className='close'></span></>}
            headMoreTxt={
                <>
                    <div className="order-top">
                        <h4><span>{item.productDescription} ({item.productNumber})</span></h4>

                    </div>
                </>
            }
            bodyMoreTxt={
                <>
                    <div className="prt-bdy-img">
                        <img src={item.productImage !=='' && item.productImage !== null ? item.productImage: NoImage} alt="Product" />
                        <div className="prt-dsc">
                            <span className="pop-prt-txt">{item.productName}</span>
                        </div>
                    </div>
                </>
            }
        />
        this.setState({ productImageIndex: e });
        this.setState({ viewImage: viewdddImage });
    }

    notDeliverable(date) {

        var authData = JSON.parse(localStorage.getItem('authData'));

        const day = date.getDay();

        return authData.accountDeliverableDays.toLowerCase().includes(this.state.allDays[day]);

    }

   enablePopup(item) {
        if ((item.productUSP !== null && item.productUSP !== "") || (item.productDiet !== null && item.productDiet !== "") || (item.productIngredient !== null && item.productIngredient !== "") || (item.productSpec !== null && item.productSpec !== "")) {
            return true;
        } else {
            return false;
        }
    }

    removeMultipleFreeProduct(){

        var decrease_product = this.state.decreaseItem;
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === decrease_product.productNumber && decrease_product.product_type === 'Normal'))) {

            if(decrease_product.product_type === 'Normal'){

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === decrease_product.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: cartItem.qty - 1
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              this.updateStateValue();
              this.getSeprateProducts();
            
            }
        }

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = this.state.offerCombineProducts;
        if(offerproductsList !== '' && offerproductsList !==''){
              productToBeAdded = offerproductsList.productToBeAdded;
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;
        var freeProductCount = 0;
        
        if(stringSplit !== ''){
            cartItems.map((cartItem) => {
                if(cartItem.product_type === 'Free'){
                    freeProductCount++;
                }
                stringSplit.filter(function(value) {
                   if(value ===  decrease_product.productNumber){
                      returnProductNumber = value;
                   }
                   if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                      previousofferProductQty += cartItem.qty;
                   }

                });
             });
         }

         var newitemsLastFinal = [];

          if(freeProductCount > 1){

            newitemsLastFinal = cartItemsNew.filter((cartItem) => (cartItem.product_type !== 'Free'));
            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));
            this.updateStateValue();
            this.getSeprateProducts();
            this.setState({decrease_alert_popup: false});
          }

            var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
            var offerproductQtyRemaing = 0;
            var productFourqty  = 0;
            var productFiveqty  = 0;
            var totalCount = 0;
            var totalCount1 = 0;
            var calculatedTotal = 0;
            var offerProductLastQty = 0;
            var typeFree = 0;

          if(stringSplit !== ''){
           cartItemsLast.map((freeItem)=>{
             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQty += freeItem.qty;
                }
              })
            });
          }

          cartItemsLast.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

             if(freeItem.product_type === 'Free'){
               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;
              calculatedTotal = totalCount + totalCount1;
              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }
    
        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        if(returnProductNumber !== 0 && (offerproductQtyRemaing == this.state.accountObjective1 || offerproductQtyRemaing > this.state.accountObjective1)){
            this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing});
        }

    }

     removeSingleOfferProduct(){

        var delete_single_Item = this.state.delete_single_Item;
        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var newitems = [];

        if (cartItems !== null && cartItems.some((cartItem) => (cartItem.productNumber === delete_single_Item.productNumber && cartItem.product_type === 'Normal'))) {

             newitems = cartItems.map((cartItem) =>

                cartItem.productNumber === delete_single_Item.productNumber && cartItem.product_type === 'Normal'
                    ? {
                        ...cartItem, 
                        qty: 0,
                    }
                    : cartItem
                
             );

              localStorage.setItem('cartItems', JSON.stringify(newitems));
              newitems = newitems.filter((cartItem) => cartItem.qty >= 1);
              this.updateStateValue();
              this.getSeprateProducts();

        }
        
        localStorage.setItem('cartItems', JSON.stringify(newitems));
        this.updateStateValue();
        this.getSeprateProducts();

        var cartItemsNew = JSON.parse(localStorage.getItem("cartItems"));
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit =  this.state.offerCombineProducts;
        if(offerproductsList !== ''){
           productToBeAdded = offerproductsList.productToBeAdded;
        }

        var previousofferProductQty = 0;
        var returnProductNumber = 0;
        var freeProductCount = 0;
        
        if(stringSplit !== ''){
            cartItems.map((cartItem) => {
                if(cartItem.product_type === 'Free'){
                    freeProductCount++;
                }
                stringSplit.filter(function(value) {
                   if(value ===  delete_single_Item.productNumber){
                      returnProductNumber = value;
                   }
                   if(value === cartItem.productNumber && cartItem.product_type !== 'Free'){
                      previousofferProductQty += cartItem.qty;
                   }

                });
             });
          }

         var newitemsLastFinal = [];

         if(freeProductCount > 1){

            newitemsLastFinal = cartItemsNew.filter((cartItem) => (cartItem.product_type !== 'Free'));

            localStorage.setItem('cartItems', JSON.stringify(newitemsLastFinal));
            this.updateStateValue();
            this.getSeprateProducts();
            this.setState({delete_item_alert_popup: false, delete_single_Item: []});
         }

           var cartItemsLast = JSON.parse(localStorage.getItem("cartItems"));
           var offerproductQtyRemaing = 0;
           var productFourqty  = 0;
           var productFiveqty  = 0;
           var totalCount = 0;
           var totalCount1 = 0;
           var calculatedTotal = 0;
           var offerProductLastQty = 0;
           var typeFree = 0;

           if(stringSplit !== ''){
            cartItemsLast.map((freeItem)=>{
             stringSplit.filter(function(value) {
                if(freeItem.productNumber === value){
                    offerProductLastQty += freeItem.qty;
                }
              })
            });
           }


           if(freeProductCount === 1){

            this.setState({delete_item_alert_popup: false, delete_single_Item: []});
            this.freeProductQtyUpdateOnly(offerProductLastQty, 'decrease');

           }

            cartItemsLast.map((freeItem)=>{

            var increment = this.state.accountObjective1;
            var increment1 = this.state.accountObjective2;

             if(freeItem.product_type === 'Free'){

               typeFree++;

              if(this.state.freeProductDataFive.includes(freeItem.productNumber)){
                increment1 = this.state.accountObjective2;
                productFiveqty = freeItem.qty;
              }else{
                increment = this.state.accountObjective1;
                productFourqty += freeItem.qty;
              }

              totalCount = increment * productFourqty;
              totalCount1 = increment1 * productFiveqty;

              calculatedTotal = totalCount + totalCount1;

              offerproductQtyRemaing = offerProductLastQty - calculatedTotal;
           }

          });

         if(typeFree === 0){
           offerproductQtyRemaing = offerProductLastQty;
         }
    
        localStorage.setItem('offerproductQtyRemaing', offerproductQtyRemaing);
        localStorage.setItem('offerproductQtyRemaing1', offerproductQtyRemaing);

        if(returnProductNumber !== 0 && (offerproductQtyRemaing == this.state.accountObjective1 || offerproductQtyRemaing > this.state.accountObjective1)){
            this.setState({checkedItems: [], freeProductOpen:true, offerProductQty:offerProductLastQty, offerproductQtyRemaing: offerproductQtyRemaing, decrease_alert_qty: 0, decreaseItem: []});
        }
    }

    popupClose(){

        this.setState({
            visibleAlert: false,
            delete_item_popup:false,
            delete_item_popup_free:false,
            common_alert_popup: false, 
            freeProductOpen: false,
            decrease_alert_popup: false,
            delete_item_alert_popup: false,
            freeProductAlert: false,
            orderDateError: false,
            creditLimitError: false,
        });
    }

    alertpopupClose(){
        this.setState({
            freeProductAlert: false,
        });
       localStorage.removeItem('reorder_free_product_exist');
    }

    CloseFreePopup =()=> {
        this.setState({freeProductOpen:false, freeProductListOpen: false});
    }

   freeProductQtyFour(productQty, item){

        var divided_by_4 = productQty / this.state.accountObjective1;;
        var firstNum4 = parseInt(divided_by_4);
        return firstNum4;
    }


   freeProductQtyFive(productQty, item){

        var divided_by_4 = productQty / this.state.accountObjective1;
        var divided_by_5 = productQty / this.state.accountObjective2;
        var firstNum4 = parseInt(divided_by_4);
        var firstNum5 = parseInt(divided_by_5);
        
        return firstNum5;    
     }


    freeProductQtyTitle(productQty){

        var divided_by_5 = productQty / this.state.accountObjective2;
        var firstNum5 = parseInt(divided_by_5);
        return firstNum5;    
    }

    calcuatedTaxAmount(totalAmount){

        var TotalAmount = totalAmount;
        var TaxAmount = 0;
        TaxAmount = (totalAmount/100)*20;
        return TaxAmount.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
    }

    orderBCLoading(){

     return (<li>
            <span className={this.state.orderPlacedStatus === true ?  'progress-status' : 'progress-status progess-load'}></span>
                <h4>Processing</h4>
                <p>Placing your order now.</p>
            </li>);
    }

    onlinePaymentLoading(){

      if(this.state.paymentmodevalue !== "Cash"){

         return(<li>
               <span className='progress-status'></span>
               <h4>Processing</h4>
               <p>Validating Card Information.</p>
                </li>
              );
        }
    }

    amountCaptureLoading(){

        if(this.state.paymentmodevalue !== "Cash"){

           return(<li> 
               <span className='progress-status progess-load'></span>
               <h4>Processing</h4>
               <p>Completing your online payment.</p>
               </li>
               );
         }
     }

    orderDateChecking(){

        var event = new Date();
        var ukTime = event.toLocaleString('en-GB', { hour: '2-digit',   hour12: false, timeZone: 'Europe/London' });
        var authData = JSON.parse(localStorage.getItem('authData'));
        var today = new Date();
        var currentTime = today.getHours();

        var tomorrow = new Date();
        var dateAfter = new Date();
        tomorrow.setDate(today.getDate() + 2);
        dateAfter.setDate(today.getDate() + 3);
        const weekday = event.getDay();

        var date = new Date();
        const theDayOfTheMonthOnNextWeek = date.getDate() + 2;
        date.setDate(theDayOfTheMonthOnNextWeek)
        var new_date = date.toISOString().split('T')[0];

        var minDate = ukTime < 14 ? new Date(new Date().getTime() + (2 * 24 * 60 * 60 * 1000)) : new Date(new Date().getTime() + (3 * 24 * 60 * 60 * 1000));

        if(weekday == '5'){

           minDate = ukTime < 14 ? new Date(new Date().getTime() + (4 * 24 * 60 * 60 * 1000)) : new Date(new Date().getTime() + (5 * 24 * 60 * 60 * 1000));

        }

        if(ukTime < 14){

        const date = new Date();
        const theDayOfTheMonthOnNextWeek = date.getDate() + 2;
        date.setDate(theDayOfTheMonthOnNextWeek)
        var new_date = date.toISOString().split('T')[0];
        var test_newDate = new_date;

        }else{

        const date = new Date();
        const theDayOfTheMonthOnNextWeek = date.getDate() + 3;
        date.setDate(theDayOfTheMonthOnNextWeek)
        var new_date = date.toISOString().split('T')[0];
        var test_newDate = new_date;

        }

        if(weekday == '5'){

         if(ukTime < 14){

            const date = new Date();
            const theDayOfTheMonthOnNextWeek = date.getDate() + 4;
            date.setDate(theDayOfTheMonthOnNextWeek)
            var new_date = date.toISOString().split('T')[0];
            var test_newDate = new_date;
    
            }else{

            const date = new Date();
            const theDayOfTheMonthOnNextWeek = date.getDate() + 5;
            date.setDate(theDayOfTheMonthOnNextWeek)
            var new_date = date.toISOString().split('T')[0];
            var test_newDate = new_date;

         }

        }

        test_newDate = moment(test_newDate).format('YYYY-MM-DD');

        var strtDt  = new Date(test_newDate);

        let DeliveryData = {};
        if (localStorage.getItem('DeliveryData')) {
            DeliveryData = JSON.parse(localStorage.getItem('DeliveryData'));
        }

        var choosedDate = moment(DeliveryData.deliveryDate).format("DD-MM-YYYY");

        //var splitDate = choosedDate.split('-');

        var valid = 'No';

        let day = strtDt.getDate();
        let month = strtDt.getMonth() + 1;
        let year = strtDt.getFullYear();

        if (day < 10) {
            day = '0' + day;
        }

        if (month < 10) {
            month = `0${month}`;
        }

        let format1 = day + "-" + month + "-" + year;

        var choosedDate2 = moment(DeliveryData.deliveryDate).format("YYYY-MM-DD");
        var GivenDate = choosedDate2;
        var CurrentDate = new Date();
        GivenDate = new Date(GivenDate);

        // console.log(GivenDate);
        // console.log(CurrentDate);
        // console.log(strtDt);

        if(GivenDate >= strtDt){
            valid = 'Yes';
        }

        return valid;

    }

    openFreeProductListnew(){

        this.setState({freeProductListOpen: true});

    }

    render() {
        var event = new Date();
        var ukTime = event.toLocaleString('en-GB', { hour: '2-digit',   hour12: false, timeZone: 'Europe/London' });
        var authData = JSON.parse(localStorage.getItem('authData'));

        if(localStorage.getItem('authData')) {
              authData = JSON.parse(localStorage.getItem('authData'));
        }

        var accountCreditLimit = authData.accountCreditLimit;


        var today = new Date();
        var currentTime = today.getHours();
        //console.log(ukTime, 'ukTime');
        var hoildays = [];
        hoildays.push(new Date('2023-03-20'));

        var tomorrow = new Date();
        var dateAfter = new Date();
        tomorrow.setDate(today.getDate() + 2);
        dateAfter.setDate(today.getDate() + 3);
        const weekday = event.getDay();

        const date = new Date();
        const theDayOfTheMonthOnNextWeek = date.getDate() + 2;
        date.setDate(theDayOfTheMonthOnNextWeek)
        var new_date = date.toISOString().split('T')[0];
        
        var minDate = ukTime < 14 ? new Date(new Date().getTime() + (2 * 24 * 60 * 60 * 1000)) : new Date(new Date().getTime() + (3 * 24 * 60 * 60 * 1000));

        if(weekday == '5'){

           minDate = ukTime < 14 ? new Date(new Date().getTime() + (4 * 24 * 60 * 60 * 1000)) : new Date(new Date().getTime() + (5 * 24 * 60 * 60 * 1000));

        }

        if(ukTime < 14){

        const date = new Date();
        const theDayOfTheMonthOnNextWeek = date.getDate() + 2;
        date.setDate(theDayOfTheMonthOnNextWeek)
        var new_date = date.toISOString().split('T')[0];
        new_date = moment(new_date).format('DD-MM-YYYY');

        }else{

        const date = new Date();
        const theDayOfTheMonthOnNextWeek = date.getDate() + 3;
        date.setDate(theDayOfTheMonthOnNextWeek)
        var new_date = date.toISOString().split('T')[0];
        new_date = moment(new_date).format('DD-MM-YYYY');

        }

        if(weekday == '5'){

         if(ukTime < 14){

            const date = new Date();
            const theDayOfTheMonthOnNextWeek = date.getDate() + 4;
            date.setDate(theDayOfTheMonthOnNextWeek)
            var new_date = date.toISOString().split('T')[0];
            new_date = moment(new_date).format('DD-MM-YYYY');

            }else{

            const date = new Date();
            const theDayOfTheMonthOnNextWeek = date.getDate() + 5;
            date.setDate(theDayOfTheMonthOnNextWeek)
            var new_date = date.toISOString().split('T')[0];
            new_date = moment(new_date).format('DD-MM-YYYY');

           }
        }

         //console.log(this.state.settingsList, 'this.state.settingsList');

         var stripePromise = '';

         if(this.state.settingsList.stripe_dev_enable == 1 && this.state.settingsList.stripe_dev_publish_id !== ''){

            stripePromise = loadStripe(this.state.settingsList.stripe_dev_publish_id);
         }

        if(this.state.settingsList.stripe_live_enable == 1 && this.state.settingsList.stripe_live_publish_id !== ''){

            stripePromise = loadStripe(this.state.settingsList.stripe_live_publish_id);
         }

        return (
            <>
                <Header />
                {!this.state.loading && 
                <main className='main-section'>
                 <section className="checkout-block">
                    <div className="sm-container">
                        <div className='checkout-header'>
                            <h1 className="dt-title">
                                <span className="dts-title">Secure Checkout</span>
                                <span>(Please review your cart details before placing order)</span>
                            </h1>

                            <div className='back-to-cat'>
                                <Link className='back-btn' to="/home"><i className="fa fa-arrow-left"></i> Back to Main</Link>
                            </div>

                        </div>
                        <div className='client-details'>
                            <h3>Account Details</h3>
                            <div className='client-detail-bx'>
                                <form className='client-detail-form'>
                                    <div className='form-field'>
                                        <input type="text" defaultValue={authData.accountName} readOnly />
                                    </div>
                                    <div className='form-field'>
                                        <input type="text" defaultValue={authData.accountCode} readOnly />
                                    </div>
                                    <div className='form-field'>
                                        <input type="text" defaultValue={authData.accountEmail} readOnly />
                                    </div>
                                    <div className='form-field field-text-area'>
                                        <textarea defaultValue={(authData.accountAddress1 !== undefined ? authData.accountAddress1 + ", ": "") + ""  + (authData.accountAddress2 !== undefined ? authData.accountAddress2 + ", " : "") + "" + (authData.accountAddress3 !== undefined ? authData.accountAddress3 + ", " : "")+ "" + (authData.accountAddress4 !== undefined ? authData.accountAddress4 + ", ": "") + "" + (authData.accountAddress5 !== undefined ? authData.accountAddress5 : "")} readOnly></textarea>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <form className='form-delivery-date'>
                            <div className="dt-flx">
                                <div className='delivery-date'>
                                    <div className="dt-innr">
                                        <span> Delivery Date<span className='required'>*</span></span>
                                        <DatePicker
                                            selected={this.state.deliveryDate}
                                            onChange={(date) => this.deliveryDateChange(date)}
                                            minDate={minDate}
                                            placeholderText="Please select any available date"
                                            filterDate={this.notDeliverable}
                                            showDisabledMonthNavigation
                                            dateFormat="dd/MM/yyyy"
                                            disablePast={true}
                                            excludeDates={this.state.holidaysDays}
                                        />
                                    </div>
                                    {this.state.deliveryDateErrMsg != "" && <span className='err-msg'> {this.state.deliveryDateErrMsg} </span>}
                                </div>

                                {/*  <div className='delivery-time'>
                                    <div className="dt-innr">
                                        <span> Delivery Time </span>
                                        <select onChange={(time) => this.deliveryTimeChange(time)}>
                                            <option>Choose Time Slot</option>
                                            {this.state.TimeSlot.map((item, i) => (
                                                <option key={i} value={item}>{item}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {this.state.deliveryTimeErrMsg != "" && <span className='err-msg'> {this.state.deliveryTimeErrMsg} </span>}
                                </div> */}
                               
                               <Contiueshopping />

                            </div>
                        </form>

                        <div className="checkout-table checkout-order">
                            <div className="table_overflow">
                                <table>
                                    <thead>
                                        <tr>
                                            <td colSpan="3">Product</td>
                                            <td align='center'>Unit of Sale</td>
                                            <td align='center'>Info</td>
                                            <td align='right'>Price</td>
                                            <td align='center' className="table-qty">Quantity</td>
                                            <td align='right'>Total</td>
                                            <td align='center'></td>
                                        </tr>
                                    </thead>
                                    <tbody className='' id="checkout-table-body">
                                        {
                                            this.state.categoryProducts && this.state.categoryProducts.map((itemCat, i) =>

                                                this.state.categories && this.state.categories.map((item, id) => {

                                                    if (itemCat[item]) {
                                                        return (<>

                                                         <tr className="prt-head-tr" key={id + i}>
                                                            <td className="prt-head" data-title="Category" colSpan="9"><span className="strong">{(item === "1" ? "PIZZA" : ((item === "10" || item === "13") ? "PASTA, RICE & NOODLE SAUCES" : "BURRITO"))}</span></td>
                                                          </tr>

                                                           { Object.keys(itemCat[item]).map((itemProduct) => {

                                                              return <>
                                                              <tr className="prt-subhead-tr" key={id + i}>
                                                                <td className="prt-head" data-title="Category" colSpan="9"><span className="strong">{itemProduct.split('-')[1]}</span></td>

                                                              </tr>
                                                             {itemCat[item][itemProduct].map((itemprod, index)=>{
            

                                                                if(itemprod.product_type === 'Normal'){
                                                                return (<tr className='' key={index}>
                                                                    <td className="prt-title" colSpan="3" data-title="Product">

                                                                        <div className={`prtf-flx ${itemprod.productImage ? '' : 'prtf-point-noneeded'}`} >
                                                                             
                                                                             <span onClick={(e) => this.handleImage(i, itemprod)} className="prt-img">
                                                                                <div className="prt-ovl">
                                                                                    <img src={itemprod.productImage !=='' && itemprod.productImage !== null ? itemprod.productImage: NoImage} alt="Product" />
                                                                                </div>
                                                                            </span>
                                                                            <span className="prt-txt" >
                                                                            <h4 onClick={(e) => this.handleImage(i, itemprod)}>
                                                                            {itemprod.productDescription} ({itemprod.productNumber})

                                                                             {itemprod.productTaxVal > 0 && <span className='color-red'>*</span>}</h4>
                                                                             
                                                                            {this.state.offerCombineProducts.length > 0 && this.state.offerCombineProducts.includes(itemprod.productNumber) &&
                                                                            <span className="offer-tag" onClick={this.openFreeProductListnew.bind(this)}><img src={discountIcon} alt="Offer" className="tag-icon" />Special Offer</span>
                                                                            }
                                                                            </span>
                                                                            
                                                                        </div>

                                                                    </td>

                                                                    <td className="unit-sale-sec" data-title="Unit of Sale">
                                                                        <span className='unit-sale-txt'>{itemprod.packageSize}</span>
                                                                    </td>

                                                                    <td className="info-sec" data-title="Info">
                                                                       {this.enablePopup(itemprod) === true && <span className="prt-info" onClick={(e) => this.handlePopup(e, itemprod)}>
                                                                            <img src={darkinfo} alt="info" className="nrm" />
                                                                            <img src={whiteinfo} alt="info" className="hov" />
                                                                        </span>}
                                                                        {this.state.viewInfo != "" && this.state.viewInfo}
                                                                    </td>


                                                                    <td align='center' width={100} className="prt-price" data-title="Price">
                                                                    {itemprod.product_type === 'Normal' ?
                                                                    <span className='prt-hide-res'>{
                                                                        this.priceFormat(itemprod.PDP_Price1 * 1)
                                                                    }</span> : <span className='prt-hide-res'>FREE
                                                                    </span>}
                                                                    </td>
                                                                    <td align='center' data-title="Quantity">
                                                                       <div className="cart-prod-qty">
                                                                            <span className="qty-val-action qty-val-minus" onClick={(e) => this.decreaseQty(e, itemprod)}>-</span>
                                                                            <input className="qty-number" type="text" readOnly value={itemprod.product_type === "Normal" ? this.state[itemprod.productNumber] : itemprod.qty} min="0" />
                                                                            <span className="qty-val-action qty-val-plus" onClick={(e) => this.increaseQty(e,itemprod)}>+</span>
                                                                
                                                                        </div>

                                                                    </td>
                                                                    <td align='center' width={120} data-title="Total" className="table-tol prt-tal">{this.priceFormat(itemprod.PDP_Price1 * itemprod.qty)}</td>
                                                                    <td className="table-del" align='center'>
                                                                        <span className="ico-del" onClick={(e) => this.deleteProduct(itemprod)}>
                                                                            <span className='txt-del'>Delete</span>
                                                                        </span>
                                                                    </td>
                                                                </tr>);
                                                                }
                                                                
                                                              })}
                                                               </>
                                                                
                                                        }
                                                      )}</>)
                                                    }
                                                })
                                            )
                                        }
                                        

                                        

                                        {this.state.offerProductQty >= this.state.accountObjective1 && this.state.freeItemCount === 0 && this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 &&  
                                        <tr className="free_product_list_wrap">
                                        <td colSpan="9">
                                        <tr className='free-title-blk'>
                                        <td colSpan="9">

                                        {this.state.offerProductQty <= 8 && 
                                        <div className='free-title-blk'> 
                                        {this.state.offerProductQty > this.state.accountObjective1 ?
                                         <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i> <span>When you select any {this.state.offerProductQty} sauces you will receive {this.freeProductQtyFour(this.state.offerProductQty)} x FREE pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x FREE rice </span></h4>
                                        : <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i><span>When you select any 4 sauces you will receive 1 x FREE pasta</span></h4>}
                                        <span className="ico-del" onClick={(e) => this.freeProductPopupOpen(e)}>
                                         <span className='txt-del'>Add</span> </span>
                                        </div>
                                        }

                                        {this.state.offerProductQty >= 9 && this.state.freeItemCount === 0 && this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 &&   
                                         <div className='free-title-blk'>
                                          <h4> FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i> <span>When you select any {this.state.offerProductQty} sauces you will receive {this.freeProductQtyFour(this.state.offerProductQty)} x FREE pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x FREE rice or a combination of both</span></h4>
                                         <span className="ico-del" onClick={(e) => this.freeProductPopupOpen(e)}>
                                          <span className='txt-del'>Add</span> </span>
                                         </div>}
 
                                        </td>
                                        </tr>
                                        </td>
                                        </tr>}


                                        {this.state.offerProductQty > 0 && this.state.freeItemCount > 0 && 
                                        <tr className="free_product_list_wrap">
                                        <td colSpan="9">
                                        <tr className='free-title-blk'>
                                        <td colSpan="9">

                                        {this.state.offerProductQty <= 8 && 
                                        <div className='free-title-blk'> 
                                        {this.state.offerProductQty > this.state.accountObjective1 ?
                                         <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i> <span>When you select any {this.state.offerProductQty} sauces you will receive {this.freeProductQtyFour(this.state.offerProductQty)} x free pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x free rice </span></h4>
                                        : <h4>FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i> <span>When you select any 4 sauces you will receive 1 x free pasta</span></h4>}
                                        <a className="free_edit_btn title-tooltip title-up" data-title='To change the FREE product setting using the edit icon.'><i className="fa fa-pencil" aria-hidden="true" onClick={(e) => this.freeProductPopupOpen(e)}></i></a>
                                        </div>
                                        }

                                        {this.state.offerProductQty >= 9 &&
                                         <div className='free-title-blk'>
                                          <h4> FREE Option <i className="fa fa-info-circle" aria-hidden="true" onClick={this.openFreeProductListnew.bind(this)}></i><span>When you select any {this.state.offerProductQty} sauces you will receive {this.freeProductQtyFour(this.state.offerProductQty)} x FREE pasta or {this.freeProductQtyTitle(this.state.offerProductQty)} x FREE rice or a combination of both</span></h4>
                                         <a className="free_edit_btn title-tooltip title-up" data-title='To change the FREE product setting using the edit icon.'><i className="fa fa-pencil" aria-hidden="true" onClick={(e) => this.freeProductPopupOpen(e)}></i></a>
                                        </div>}

                                       </td>
                                        </tr>
                                        {
                                            this.state.categoryProductsFree && this.state.categoryProductsFree.map((itemCat, i) =>

                                                this.state.categories && this.state.categories.map((item, id) => {
                                                    if (itemCat[item]) {
                                                        return (<>
                                                            {itemCat[item].map((itemProduct, index) => {
                                                                if(itemProduct.product_type === 'Free'){
                                                                return (<tr className='free_product_list' key={index}>
                                                                    <td className="prt-title" data-title="Product">

                                                                        <div className={`prtf-flx ${itemProduct.productImage ? '' : 'prtf-point'}`} onClick={(e) => this.handleImage(i, itemProduct)}>
                                                                             <span className="prt-img">
                                                                                <div className="prt-ovl">
                                                                                    <img src={itemProduct.productImage !== '' ? itemProduct.productImage : NoImage } alt="Product" />
                                                                                </div>
                                                                            </span>
                                                                            <span className="prt-txt">{itemProduct.productDescription} ({itemProduct.productNumber})
                                                                             <span className="free-category-title">{(item === "1" ? "(PIZZA)" : ((item === "10" || item === "13") ? "(PASTA, RICE & NOODLE SAUCES)" : "(BURRITO)"))}
                                                                            </span>
                                                                            </span>

                                                                        </div>

                                                                    </td>

                                                                    <td className="unit-sale-sec" data-title="Unit of Sale">
                                                                        <span className='unit-sale-txt'>{itemProduct.packageSize}</span>
                                                                    </td>

                                                                    <td className="info-sec" data-title="Info">
                                                                       {this.enablePopup(itemProduct) === true && <span className="prt-info" onClick={(e) => this.handlePopup(e, itemProduct)}>
                                                                            <img src={darkinfo} alt="info" className="nrm" />
                                                                            <img src={whiteinfo} alt="info" className="hov" />
                                                                        </span>}
                                                                        {this.state.viewInfo != "" && this.state.viewInfo}
                                                                    </td>


                                                                    <td align='center' width={100} className="prt-price" data-title="Price">
                                                                    {itemProduct.product_type === 'Normal' ?
                                                                    <span className='prt-hide-res'>{
                                                                        this.priceFormat(itemProduct.PDP_Price1 * 1)
                                                                    }</span> : <span className='prt-hide-res'>FREE
                                                                    </span>}
                                                                    </td>
                                                                    <td align='center' data-title="Quantity">
                                                                       <div className="cart-prod-qty">
                                                                            <span className="qty-val-action qty-val-minus" onClick={(e) => this.decreaseQty(e, itemProduct)}>-</span>
                                                                            <input className="qty-number" type="text" readOnly value={itemProduct.product_type === "Normal" ? this.state[itemProduct.productNumber] : itemProduct.qty} min="0" />
                                                                            <span className="qty-val-action qty-val-plus" onClick={(e) => this.increaseQty(e,itemProduct)}>+</span>
                                                                         
                                                                        </div>

                                                                    </td>
                                                                    <td align='center' width={120} data-title="Total" className="table-tol prt-tal">{this.priceFormat(itemProduct.PDP_Price1 * itemProduct.qty)}</td>
                                                                    <td className="table-del" align='center'>
                                                                        <span className="ico-del" onClick={(e) => this.deleteProduct(itemProduct)}>
                                                                            <span className='txt-del'>Delete</span>
                                                                        </span>
                                                                    </td>
                                                                </tr>);
                                                            }})}</>)
                                                    }
                                                })
                                            )
                                        }
                                        </td>
                                        </tr>}

                                        <tr className="no-line total">
                                            <td colSpan="5"></td>
                                            <td colSpan="2" width={160}>
                                                <span className="strong">Sub Total:</span>
                                            </td>
                                            <td className="table-tol prt-tal">
                                                {this.state.cartSubTotal}
                                            </td>
                                            <td></td>
                                        </tr>

                                        {this.state.taxProductTotalAmount > 0 && 
                                        <tr className="no-line total">
                                            <td colSpan="5"></td>
                                            <td colSpan="2" width={160} className='td-vat-fee'>
                                                <span className="strong">VAT <span className='vat-txt'>(20% of <span className='vat-amt'>{this.priceFormat(this.state.taxProductTotalAmount)}</span>)<span className='color-red'>*</span> :</span></span>
                                            </td>
                                            <td className="table-tol prt-tal">{this.calcuatedTaxAmount(this.state.taxProductTotalAmount)}</td>
                                            <td></td>
                                        </tr>
                                        }

                                        <tr className="no-line total">
                                            <td colSpan="5"></td>
                                            <td colSpan="2" width={160} className='td-free-del'>
                                                <span className="strong">Shipping:</span>
                                            </td>
                                            <td className="table-tol prt-tal" style={{color: "#db4758"}}>FREE</td>
                                            <td></td>
                                        </tr>

                                        {/*<tr className="no-line total">
                                            <td colSpan="6"></td>
                                            <td width={160} className='td-free-del'>
                                                <span className="">Shipping Free</span>
                                            </td>
                                            <td className="table-tol prt-tal">&nbsp;</td>
                                            <td></td>
                                        </tr>*/}


                                        <tr className="no-line total">
                                            <td colSpan="5"></td>
                                            <td colSpan="2" width={160}>
                                                <span className="strong">Grand Total:</span>
                                            </td>
                                            <td className="table-tol prt-tal">
                                                {this.state.cartTotal}
                                            </td>
                                            <td></td>
                                        </tr>



                                    </tbody>
                                </table>

                             {this.state.viewImage != "" && this.state.viewImage}


                             {JSON.parse(localStorage.getItem("cartItems")).length > 0 && <div className='chk-btn-holder chk-btn-wrap'>
                                    <div className='agree-terms'>
                                        <div className='check-box'>
                                            <input type="checkbox" id="chkbox" />
                                            <label htmlFor="chkbox">Please agree with our <a target="_blank" href="https://www.tugo.co.uk/terms-and-conditions" >terms and conditions</a> and <a target="_blank" href="https://www.tugo.co.uk/privacy-policy" >privacy policy</a><span className='required'>*</span></label>
                                        </div>
                                        {this.state.checkboxErrMsg != "" && <span className='err-msg'> {this.state.checkboxErrMsg} </span>}
                                    </div>
                                    {!this.state.payBool && <button value={this.state.payBool} className="pay-btn button" onClick={(e) => this.payNow(e)}>Pay Now</button>}

                                    {authData.accountPaymentMethod === 'No' && !this.state.payBool && <button value={this.state.payBool} className="pay-btn button" onClick={(e) => this.payLater()}>Pay Later</button>}
                                    {this.state.payBool && <button value={this.state.payBool} className="button" onClick={(e) => this.payNow(e)}>Close</button>}
                                </div>}

                              {/*<div className='payment-opt'>
                                    <div className='pay-accept'>
                                        <img src={payMethImg} alt="OffPaymenter" className="pay-meth-img" />
                                    </div>
                                </div>*/}

                            </div>
                        </div>

                    </div>

                       {this.state.payBool &&
                            <Elements stripe={stripePromise}>
                                <CheckoutForm closeBTN={<><span className="popup-close" onClick={(e => this.payNow(e))}></span></>} />
                            </Elements>
                        }

                </section>
               </main>}

                {this.state.alertPopup === true && <Showalert title='oops!' message="The Server is busy, please try after sometime or contact us to place your order" />
                }

                {this.state.visibleAlert === true && 
                <div className='custom-alert-pop paylater-popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>Are you sure you want to place an order without online payment?</p>
                                <div className='alert-buttons'>
                                    <a onClick={this.payLaterOrder.bind(this)} className="popup-alert-btn button" disabled={this.state.disableButton > 0 ? true : false}>OK</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}


               {this.state.delete_item_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Delete Item</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>Are you sure you want to delete this item?</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.clearSingleItem.bind(this)}>Ok</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              }
                
              {this.state.delete_item_popup_free === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Remove Item</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.delete_item_popup_free_message}</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.clearSingleItemFree.bind(this)}>Ok</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              }

            
             {this.state.common_alert_popup === true && 
              <div className='custom-alert-pop common_alert_popup'>
                <div className='custom-alert-container'>
                    <div className='custom-alert-wrap'>
                        <div className='custom-alert-header'>
                            <h4>Alert</h4>
                        </div>
                        <div className='custom-alert-body'>
                            <p>{this.state.common_alert_message}</p>
                            <div className='alert-buttons'>
                                <a onClick={this.freeProductClear.bind(this)} className="popup-alert-btn button">OK</a>
                                <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }


            {this.state.decrease_alert_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.decrease_alert_popup_message}</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.removeMultipleFreeProduct.bind(this)}>OK</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            {this.state.delete_item_alert_popup === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>{this.state.delete_item_alert_message}</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={this.removeSingleOfferProduct.bind(this)}>OK</a>
                                    <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}


             {this.state.freeProductAlert === true && 
                  <div className='custom-alert-pop common_alert_popup'>
                    <div className='custom-alert-container'>
                        <div className='custom-alert-wrap'>
                            <div className='custom-alert-header'>
                                <h4>Alert</h4>
                            </div>
                            <div className='custom-alert-body'>
                                <p>Your order is eligible to select FREE products. Please make your selection.</p>
                                <div className='alert-buttons'>
                                    <a className="popup-alert-btn button" onClick={(e) => this.freeProductPopupOpen(e)}>OK</a>
                                    <a onClick={this.alertpopupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}


            {this.state.minmumAmountError === true && 
              <div className='custom-alert-pop'>
                <div className='custom-alert-container'>
                    <div className='custom-alert-wrap'>
                        <div className='custom-alert-header'>
                            <h4>Minimum Cart Value</h4>
                        </div>
                        <div className='custom-alert-body'>
                            <p>You haven't reached your minimum order amount of  £{this.state.minimumOrderAmount}, please add additional items to your cart and place your order.
                            </p>
                            <div className='alert-buttons'>
                                <a className="popup-alert-btn button" href="/checkout/pizza">Ok</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

            {this.state.creditLimitError === true && 
              <div className='custom-alert-pop'>
                <div className='custom-alert-container'>
                    <div className='custom-alert-wrap'>
                        <div className='custom-alert-header'>
                            <h4>Alert</h4>
                        </div>
                        <div className='custom-alert-body'>
                            <p>
                            Your order amount exceeds your maximum credit limit of £{accountCreditLimit}, please reduce your order value and place your order or contact our customer service team on: 01295 367351. 
                            </p>
                            <div className='alert-buttons'>
                                <a className="popup-alert-btn button" onClick={this.popupClose.bind(this)}>Ok</a>
                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

            {this.state.deliveryDateError === true && 
              <div className='custom-alert-pop'>
                <div className='custom-alert-container'>
                    <div className='custom-alert-wrap'>
                        <div className='custom-alert-header'>
                            <h4>Alert</h4>
                        </div>
                        <div className='custom-alert-body'>
                            <p>The route days are not set for this account, please contact our customer service team on: 01295 367351.</p>
                            <div className='alert-buttons'>
                                <a className="popup-alert-btn button" href="/checkout/pizza">Ok</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

           {this.state.uktimeerror === true && 
            <div className='custom-alert-pop'>
            <div className='custom-alert-container'>
                <div className='custom-alert-wrap'>
                    <div className='custom-alert-header'>
                        <h4>Alert</h4>
                    </div>
                    <div className='custom-alert-body'>
                        <p>Selected date not available, So Please choose another date.</p>
                        <div className='alert-buttons'>
                            <a className="popup-alert-btn button" href="/checkout/pizza">Ok</a>
                        </div>
                    </div>
                </div>
            </div>
           </div> }


            {this.state.orderDateError === true && 
              <div className='custom-alert-pop'>
                <div className='custom-alert-container'>
                    <div className='custom-alert-wrap'>
                        <div className='custom-alert-header'>
                            <h4>Alert</h4>
                        </div>
                        <div className='custom-alert-body'>
                            <p>The date selected by you is not available, Please choose the next available date.</p>
                            <div className='alert-buttons'>
                                <a className="popup-alert-btn button" onClick={this.popupClose.bind(this)}>Ok</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

             {this.state.viewInfoPayment === true && 

                <Popup
                 extClass="info-poup payment-popup show"
                 headMoreTxt={
                 <>
                    <div className="order-top">
                        <h4>We Are Processing Your Order</h4>
                    </div>
                 </>
                 }
                 bodyMoreTxt={
                 <>
                    <div className="info-bdy">
                        <div className='order-progress-wrap'>
                            <ul className='odr-progress-list'>
  
                                {this.onlinePaymentLoading()}

                                {this.orderBCLoading()}

                                {this.amountCaptureLoading()}

                            </ul>
                        </div>
                    </div>
                </>
                 }
                 />

                }

                {this.state.freeProductOpen === true && this.state.freeProductData.data !== undefined && this.state.freeProductData.data.length > 0 && this.state.offerProductQty >= this.state.accountObjective1 && 
                 <FreeProductPopup addfreepro={this.addFreeProduct.bind(this)} freeval = {this.state.checkedItems} productQty={this.state.offerProductQty} freeProduct={this.state.freeProductData} freeProduct1={this.state.freeProductDataFour} freeProduct2={this.state.freeProductDataFive}productValueIndex={this.state.productValueIndex} productQtyRemaing={this.state.offerproductQtyRemaing} closefreepro={this.CloseFreePopup.bind(this)} accountObjective1 = {this.state.accountObjective1} accountObjective2 = {this.state.accountObjective2} />
                }

                {this.state.freeProductListOpen === true  && this.state.offerProductData.length > 0 && 
                 <FreeProductListPopup addfreepro={this.addFreeProduct.bind(this)} freeval = {this.state.checkedItems} productQty={this.state.offerProductQty} freeProduct ={this.state.freeProductData} freeProduct1={this.state.freeProductDataFour} freeProduct2={this.state.freeProductDataFive} productValueIndex={this.state.productValueIndex} productQtyRemaing={this.state.offerproductQtyRemaing} closefreepro={this.CloseFreePopup.bind(this)} offerProductData = {this.state.offerProductData} />
                }




                 {this.state.loading && <main className='main-section'> <Loader propsClassName="load-lag" /> </main>}
                <Footer />
            </>
        );
    }
}


export default CheckoutPay;